/* eslint-disable */
// GENERATED FILE — do not edit. Run `npm run catalog:build` after changing catalog/**.
// Source of truth: catalog/<area>/<ID>.md. `npm run catalog:check` fails when this is stale.
import type { CatalogEntry } from './types';

/** Fingerprint of the catalog sources this file was built from. */
export const CATALOG_HASH = 'bee78cf26cbdd7d088e2feaaf975b53e3c7018c5f3d36ecc1b69c739227f9781';

export const CATALOG_ENTRIES: readonly CatalogEntry[] =
  [
    {
      "id": "BNK-001",
      "area": "bank-statements",
      "job": "Import a bank statement from the bank's XML file",
      "description": "Click \"Add bank statement\", choose \"Import from XML file\", drag the CAMT XML file into the dialog (or click \"Browse Files\") and click \"Import\". PCT creates the statement with all its entries, fills in the payer where it can recognise the client, and marks outgoing payments to insurers, GrECo commission and bank fees as cleared straight away. Only CAMT.052 and CAMT.053 files (version 001.02) are accepted; a statement that was already imported is refused, and entries already imported from an overlapping file are skipped.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT. The statement must belong to a GrECo company you are allowed to work for.",
      "aliases": [
        "upload bank statement",
        "camt",
        "camt.053",
        "camt.052",
        "bank file",
        "load payments from bank",
        "import xml statement",
        "upload statement from internet bank",
        "add bank statement",
        "import bank payments"
      ],
      "anchor": "bank-statements-add-import",
      "anchor_surface": "bank-statements-add-menu",
      "anchor_action": "open",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Importuoti banko išrašą iš banko XML failo",
          "description": "Spustelėkite „Pridėkite banko išrašą“, pasirinkite „Import from XML file“, nutempkite CAMT XML failą į langą (arba spauskite „Ieškoti“) ir spauskite „Importuoti“. PCT sukuria išrašą su visais įrašais, užpildo mokėtoją, kai pavyksta atpažinti klientą, o išeinančius mokėjimus draudikams, GrECo komisinius ir banko mokesčius iš karto pažymi kaip užskaitytus. Priimami tik CAMT.052 ir CAMT.053 failai (versija 001.02); jau importuotas išrašas atmetamas, o iš persidengiančio failo jau importuoti įrašai praleidžiami.",
          "prerequisites": "Rašymo teisės PCT. Išrašas turi priklausyti GrECo įmonei, kurios duomenis jums leidžiama tvarkyti.",
          "aliases": [
            "įkelti banko išrašą",
            "importuoti banko israsa",
            "banko išrašas xml",
            "camt failas",
            "ikelti israsa",
            "banko failas",
            "įkelti mokėjimus iš banko"
          ]
        },
        "lv": {
          "job": "Importēt bankas izrakstu no bankas XML faila",
          "description": "Noklikšķiniet uz “Add bank statement”, izvēlieties “Import from XML file”, ievelciet CAMT XML failu logā (vai noklikšķiniet uz “Browse Files”) un noklikšķiniet uz “Import”. PCT izveido izrakstu ar visiem ierakstiem, aizpilda maksātāju, ja izdodas atpazīt klientu, un izejošos maksājumus apdrošinātājiem, GrECo komisiju un bankas komisiju uzreiz atzīmē kā nokārtotus. Tiek pieņemti tikai CAMT.052 un CAMT.053 faili (versija 001.02); jau importēts izraksts tiek noraidīts, bet no pārklājoša faila jau importētie ieraksti tiek izlaisti.",
          "prerequisites": "Rakstīšanas tiesības PCT. Izrakstam jāpieder GrECo uzņēmumam, ar kura datiem jums atļauts strādāt.",
          "aliases": [
            "augšupielādēt bankas izrakstu",
            "importēt bankas izrakstu",
            "importet izrakstu",
            "camt fails",
            "bankas fails",
            "ielādēt maksājumus no bankas",
            "konta izraksts xml"
          ]
        }
      }
    },
    {
      "id": "BNK-002",
      "area": "bank-statements",
      "job": "Enter a bank statement by hand",
      "description": "Click \"Add bank statement\" and choose \"Enter manually\". An empty statement appears at the top of the list in edit mode (currency EUR, today as creation date): fill in the cells and save it with the green tick in its Options column. Then click \"Add Bank Statement Entry\" in the same column to add entries; each entry needs at least an amount and the client account, and is saved with its own green tick. Currency and company cannot be changed after the statement is saved.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT. Use this only for statements you do not have as a CAMT XML file.",
      "aliases": [
        "manual bank statement",
        "add statement manually",
        "create bank statement",
        "enter payment manually",
        "add bank entry by hand",
        "type in a bank statement",
        "add bank statement entry"
      ],
      "anchor": "bank-statements-add-manual",
      "anchor_surface": "bank-statements-add-menu",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Įvesti banko išrašą ranka",
          "description": "Spustelėkite „Pridėkite banko išrašą“ ir pasirinkite „Enter manually“. Sąrašo viršuje atsiranda tuščias redaguojamas išrašas (valiuta EUR, sukūrimo data – šiandien): užpildykite langelius ir išsaugokite žalia varnele jo stulpelyje „Nustatymai“. Tada tame pačiame stulpelyje spauskite „Add Bank Statement Entry“ ir pridėkite įrašus; kiekvienam įrašui reikia bent sumos ir kliento sąskaitos, jis išsaugomas savo žalia varnele. Išsaugojus išrašą, valiutos ir įmonės pakeisti nebegalima.",
          "prerequisites": "Rašymo teisės PCT. Naudokite tik išrašams, kurių neturite CAMT XML failo pavidalu.",
          "aliases": [
            "įvesti išrašą ranka",
            "ivesti israsa ranka",
            "sukurti banko išrašą",
            "rankinis banko išrašas",
            "pridėti banko įrašą"
          ]
        },
        "lv": {
          "job": "Ievadīt bankas izrakstu manuāli",
          "description": "Noklikšķiniet uz “Add bank statement” un izvēlieties “Enter manually”. Saraksta augšā parādās tukšs rediģējams izraksts (valūta EUR, izveides datums – šodiena): aizpildiet šūnas un saglabājiet ar zaļo ķeksīti tā kolonnā “Options”. Pēc tam tajā pašā kolonnā noklikšķiniet uz “Add Bank Statement Entry”, lai pievienotu ierakstus; katram ierakstam vajag vismaz summu un klienta kontu, un to saglabā ar savu zaļo ķeksīti. Pēc izraksta saglabāšanas valūtu un uzņēmumu mainīt nevar.",
          "prerequisites": "Rakstīšanas tiesības PCT. Izmantojiet tikai izrakstiem, kas jums nav pieejami kā CAMT XML fails.",
          "aliases": [
            "ievadīt izrakstu manuāli",
            "ievadit izrakstu manuali",
            "izveidot bankas izrakstu",
            "manuāls bankas izraksts",
            "pievienot bankas ierakstu"
          ]
        }
      }
    },
    {
      "id": "BNK-003",
      "area": "bank-statements",
      "job": "Find a bank statement or a payment in it",
      "description": "The list loads statements of the GrECo companies ticked at the top right whose date falls in the date range; by default the last three months of \"Statement created at\" (switch to \"Period from\" or \"Period to\" in the list next to the dates). Then type in the search box: it matches the statement comment, account owner, company, currency, balances and dates, and in the entries the client name, client code, client account, payment reference and comment. Statements with a matching entry are ticked automatically so the entry shows in the lower list; amounts and payment dates are not searched.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "search bank statement",
        "find payment from client",
        "find incoming payment",
        "statement not showing",
        "filter statements by date",
        "search by payment reference",
        "where is my bank statement",
        "find entry by client name"
      ],
      "anchor": "bank-statements-search",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Rasti banko išrašą arba jame esantį mokėjimą",
          "description": "Sąraše įkeliami viršuje dešinėje pažymėtų GrECo įmonių išrašai, kurių data patenka į laikotarpį; pagal nutylėjimą – paskutiniai trys mėnesiai pagal „Įrašas sukurtas“ (šalia datų esančiame sąraše galima pasirinkti „Laikotarpis nuo“ arba „Laikotarpis iki“). Tada rašykite paieškos laukelyje: ieškoma išrašo komentare, sąskaitos savininko, įmonės, valiutos, likučių ir datų laukuose, o įrašuose – kliento pavadinime, kliento kode, kliento sąskaitoje, mokėjimo numeryje ir komentare. Išrašai su atitinkančiu įrašu pažymimi automatiškai, todėl įrašas matomas apatiniame sąraše; sumose ir mokėjimo datose neieškoma.",
          "aliases": [
            "rasti banko išrašą",
            "rasti mokejima",
            "ieškoti išrašo",
            "paieška pagal mokėjimo numerį",
            "nerodo išrašo",
            "filtruoti išrašus pagal datą"
          ]
        },
        "lv": {
          "job": "Atrast bankas izrakstu vai tajā esošu maksājumu",
          "description": "Sarakstā tiek ielādēti augšā pa labi atzīmēto GrECo uzņēmumu izraksti, kuru datums ir periodā; pēc noklusējuma – pēdējie trīs mēneši pēc “Statement created at” (sarakstā blakus datumiem var izvēlēties “Period from” vai “Period to”). Pēc tam rakstiet meklēšanas laukā: meklē izraksta komentārā, konta īpašnieka, uzņēmuma, valūtas, atlikumu un datumu laukos, bet ierakstos – klienta nosaukumā, klienta kodā, klienta kontā, maksājuma numurā un komentārā. Izraksti ar atbilstošu ierakstu tiek atzīmēti automātiski, lai ieraksts būtu redzams apakšējā sarakstā; summās un maksājuma datumos netiek meklēts.",
          "aliases": [
            "atrast bankas izrakstu",
            "atrast maksajumu",
            "meklēt izrakstu",
            "meklēt pēc maksājuma numura",
            "izraksts nav redzams",
            "filtrēt izrakstus pēc datuma"
          ]
        }
      }
    },
    {
      "id": "BNK-004",
      "area": "bank-statements",
      "job": "Assign the paying client to a bank statement entry",
      "description": "Tick the statement in the upper list so its entries show below. On an entry without a payer, click \"Suggest client resolvement\" (the person-with-question-mark icon) to fill in a matching client, or pick the client yourself in the Payer cell, then save the entry with its green tick. To get suggestions for every entry at once, use the same icon in the statement's Options column and confirm each suggested entry with its green tick. Suggestions use the client number before the first \"-\" in the payment reference, the payer's company or personal code and the payer's name.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The entry must not be cleared yet.",
      "aliases": [
        "resolve client",
        "resolve payer",
        "suggest client resolvement",
        "unresolved entry",
        "match payment to client",
        "set payer on bank entry",
        "who paid this",
        "assign client to payment",
        "unknown payer",
        "dont know who paid, money came in from unknown client, incoming money without a client"
      ],
      "anchor": "bank-statements-entries-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Priskirti mokantį klientą banko išrašo įrašui",
          "description": "Viršutiniame sąraše pažymėkite išrašą, kad apačioje matytumėte jo įrašus. Įraše be mokėtojo spauskite „Suggest client resolvement“ (žmogaus su klaustuku piktograma), kad būtų užpildytas atitinkantis klientas, arba patys pasirinkite klientą langelyje „Mokėtojas“, tada išsaugokite įrašą jo žalia varnele. Pasiūlymams visiems įrašams iš karto naudokite tą pačią piktogramą išrašo stulpelyje „Nustatymai“ ir kiekvieną pasiūlytą įrašą patvirtinkite jo žalia varnele. Pasiūlymai remiasi kliento numeriu prieš pirmąjį „-“ mokėjimo numeryje, mokėtojo įmonės ar asmens kodu ir mokėtojo pavadinimu.",
          "prerequisites": "Įrašas dar neturi būti užskaitytas.",
          "aliases": [
            "priskirti mokėtoją",
            "priskirti klienta mokejimui",
            "nežinomas mokėtojas",
            "nustatyti klientą",
            "kas sumokėjo",
            "susieti mokėjimą su klientu"
          ]
        },
        "lv": {
          "job": "Piesaistīt maksājušo klientu bankas izraksta ierakstam",
          "description": "Augšējā sarakstā atzīmējiet izrakstu, lai zemāk redzētu tā ierakstus. Ierakstā bez maksātāja noklikšķiniet uz “Suggest client resolvement” (cilvēka ar jautājuma zīmi ikona), lai aizpildītu atbilstošu klientu, vai izvēlieties klientu pats šūnā “Payer”, pēc tam saglabājiet ierakstu ar tā zaļo ķeksīti. Lai saņemtu ieteikumus visiem ierakstiem uzreiz, izmantojiet to pašu ikonu izraksta kolonnā “Options” un katru ieteikto ierakstu apstipriniet ar tā zaļo ķeksīti. Ieteikumi balstās uz klienta numuru pirms pirmās “-” maksājuma numurā, maksātāja uzņēmuma vai personas kodu un maksātāja nosaukumu.",
          "prerequisites": "Ieraksts vēl nedrīkst būt nokārtots.",
          "aliases": [
            "piesaistīt maksātāju",
            "piesaistit klientu maksajumam",
            "nezināms maksātājs",
            "noteikt klientu",
            "kas samaksāja",
            "sasaistīt maksājumu ar klientu"
          ]
        }
      }
    },
    {
      "id": "BNK-005",
      "area": "bank-statements",
      "job": "Clear a received payment against the client's premium",
      "description": "Tick the statement, then on the entry click \"Clear bank statement entry\" (the split-arrow icon). The dialog lists the client's open payment-plan entries in the entry's currency and pre-fills \"To be cleared\" by spreading the amount over them; narrow the list with the booking-date range, insurer, payment reference, policy and other filters and click \"Search\", or adjust amounts per row (a light-red row belongs to a cancelled policy — check it before clearing against it). Click \"Clear\": a payment is created for every row with an amount, any unallocated remainder goes to the client balance, and the entry is marked cleared. \"Clear\" stays disabled while the total exceeds the payment.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The entry must have a payer and a positive amount, and must not be cleared yet.",
      "aliases": [
        "clear bank entry",
        "match payment to premium",
        "settle premium",
        "allocate payment to policies",
        "pay installments from bank payment",
        "clearance",
        "apply payment to payment plan",
        "offset premium debt"
      ],
      "anchor": "bank-statements-entries-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Užskaityti gautą mokėjimą kliento įmokoms",
          "description": "Pažymėkite išrašą, tada įraše spauskite „Clear bank statement entry“ (išsišakojančios rodyklės piktograma). Lange rodomi neapmokėti kliento mokėjimų plano įrašai įrašo valiuta, o stulpelis „To be cleared“ iš anksto užpildomas paskirstant sumą; susiaurinkite sąrašą registravimo datos laikotarpiu, draudiku, mokėjimo numeriu, polisu ir kitais filtrais ir spauskite „Ieškoti“ arba keiskite sumas eilutėse (šviesiai raudona eilutė priklauso nutrauktam polisui – patikrinkite ją prieš užskaitydami). Spauskite „Išvalyti“: kiekvienai eilutei su suma sukuriamas mokėjimas, nepaskirstytas likutis atitenka kliento balansui, o įrašas pažymimas kaip užskaitytas. Kol suma viršija mokėjimą, mygtukas neaktyvus.",
          "prerequisites": "Įrašas turi turėti mokėtoją ir teigiamą sumą bei dar nebūti užskaitytas.",
          "aliases": [
            "užskaityti mokėjimą",
            "uzskaityti imoka",
            "priskirti mokėjimą įmokoms",
            "padengti skolą",
            "užskaitymas",
            "išskaidyti mokėjimą polisams"
          ]
        },
        "lv": {
          "job": "Nokārtot saņemto maksājumu pret klienta prēmiju",
          "description": "Atzīmējiet izrakstu, tad ierakstā noklikšķiniet uz “Clear bank statement entry” (sazarotas bultas ikona). Logā redzami klienta neapmaksātie maksājumu grafika ieraksti ieraksta valūtā, un kolonna “To be cleared” ir iepriekš aizpildīta, sadalot summu; sašauriniet sarakstu ar grāmatošanas datuma periodu, apdrošinātāju, maksājuma numuru, polisi un citiem filtriem un noklikšķiniet uz “Search” vai mainiet summas rindās (gaiši sarkana rinda pieder anulētai polisei – pārbaudiet to pirms nokārtošanas). Noklikšķiniet uz “Clear”: katrai rindai ar summu tiek izveidots maksājums, nesadalītais atlikums nonāk klienta saldo, un ieraksts tiek atzīmēts kā nokārtots. Kamēr kopsumma pārsniedz maksājumu, poga nav aktīva.",
          "prerequisites": "Ierakstam jābūt maksātājam un pozitīvai summai, un tas vēl nedrīkst būt nokārtots.",
          "aliases": [
            "nokārtot maksājumu",
            "nokartot ierakstu",
            "sasaistīt maksājumu ar prēmiju",
            "segt prēmijas parādu",
            "sadalīt maksājumu polisēm",
            "ieskaitīt maksājumu"
          ]
        }
      }
    },
    {
      "id": "BNK-006",
      "area": "bank-statements",
      "job": "Clear all entries that match a reminder exactly",
      "description": "Tick the statement and click \"Clear all perfect matches\" (the circling-arrows icon) in its Options column, then \"Confirm\". Every entry of that statement that has a payer, is not cleared yet and whose payment reference is a reminder number, or contains the number of exactly one of the client's reminders, is cleared against that reminder, provided nothing has been paid on the reminder and the amounts are equal. The dialog shows how many entries were cleared and offers \"Export Excel\"; after closing, those entries are highlighted in the lower list.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT. Entries need a payer first.",
      "aliases": [
        "perfect match",
        "clear all perfect matches",
        "auto clear by reminder",
        "match payments to reminders",
        "automatic clearance",
        "bulk clear statement",
        "clear by reminder number"
      ],
      "anchor": "bank-statements-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Užskaityti visus įrašus, tiksliai atitinkančius priminimą",
          "description": "Pažymėkite išrašą, jo stulpelyje „Nustatymai“ spauskite „Išvalyti visus tobulus atitikmenis“ (apskritų rodyklių piktograma), tada „Patvirtinti“. Kiekvienas to išrašo įrašas, kuris turi mokėtoją, dar nėra užskaitytas ir kurio mokėjimo numeris yra priminimo numeris arba jame yra lygiai vieno kliento priminimo numeris, užskaitomas pagal tą priminimą, jei pagal jį dar niekas nesumokėta ir sumos sutampa. Lange parodoma, kiek įrašų užskaityta, ir siūloma „Export Excel“; uždarius langą tie įrašai apatiniame sąraše paryškinami.",
          "prerequisites": "Rašymo teisės PCT. Įrašai pirmiausia turi turėti mokėtoją.",
          "aliases": [
            "tobuli atitikmenys",
            "isvalyti visus tobulus atitikmenis",
            "automatinis užskaitymas",
            "užskaityti pagal priminimą",
            "masinis užskaitymas"
          ]
        },
        "lv": {
          "job": "Nokārtot visus ierakstus, kas precīzi atbilst atgādinājumam",
          "description": "Atzīmējiet izrakstu, tā kolonnā “Options” noklikšķiniet uz “Notīrīt visas ideālās atbilstības” (apļveida bultu ikona), pēc tam uz “Apstiprināt”. Katrs šī izraksta ieraksts, kuram ir maksātājs, kas vēl nav nokārtots un kura maksājuma numurs ir atgādinājuma numurs vai satur tieši viena klienta atgādinājuma numuru, tiek nokārtots pret šo atgādinājumu, ja pēc tā vēl nekas nav samaksāts un summas sakrīt. Logā redzams, cik ierakstu nokārtots, un piedāvāts “Export Excel”; pēc aizvēršanas šie ieraksti apakšējā sarakstā ir izcelti.",
          "prerequisites": "Rakstīšanas tiesības PCT. Ierakstiem vispirms jābūt maksātājam.",
          "aliases": [
            "ideālās atbilstības",
            "notirit visas idealas atbilstibas",
            "automātiska nokārtošana",
            "nokārtot pēc atgādinājuma",
            "masveida nokārtošana"
          ]
        }
      }
    },
    {
      "id": "BNK-007",
      "area": "bank-statements",
      "job": "Book a negative bank entry to the client balance",
      "description": "Negative entries are hidden by default: tick \"Include negative amounts\" below the entries list, and tick the statement in the upper list. On the entry, after it has a payer, click \"Clear bank statement entry\"; for a negative or zero amount PCT asks whether to clear the amount to that client's balance. Check the amount and client in the question and click \"Clear\" — the whole amount is booked to the client balance and the entry is marked cleared.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The entry must have a payer and must not be cleared yet.",
      "aliases": [
        "clear to client balance",
        "clear to saldo",
        "negative entry",
        "refund to client",
        "outgoing payment to client",
        "book to client saldo",
        "show negative amounts"
      ],
      "anchor": "bank-statements-entry-filters",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Įrašyti neigiamą banko įrašą į kliento balansą",
          "description": "Neigiami įrašai pagal nutylėjimą paslėpti: po įrašų sąrašu pažymėkite „Įtraukti neigiamas sumas“, o viršutiniame sąraše pažymėkite išrašą. Kai įrašas turi mokėtoją, spauskite „Clear bank statement entry“; neigiamai ar nulinei sumai PCT klausia, ar užskaityti sumą į to kliento balansą. Patikrinkite klausime nurodytą sumą ir klientą ir spauskite „Clear“ – visa suma įrašoma į kliento balansą, o įrašas pažymimas kaip užskaitytas.",
          "prerequisites": "Įrašas turi turėti mokėtoją ir dar nebūti užskaitytas.",
          "aliases": [
            "užskaityti į kliento balansą",
            "neigiamas įrašas",
            "grąžinimas klientui",
            "kliento saldo",
            "rodyti neigiamas sumas",
            "neigiama suma"
          ]
        },
        "lv": {
          "job": "Iegrāmatot negatīvu bankas ierakstu klienta saldo",
          "description": "Negatīvie ieraksti pēc noklusējuma ir paslēpti: zem ierakstu saraksta atzīmējiet “Iekļaut negatīvās summas” un augšējā sarakstā atzīmējiet izrakstu. Kad ierakstam ir maksātājs, noklikšķiniet uz “Clear bank statement entry”; negatīvai vai nulles summai PCT jautā, vai nokārtot summu uz šī klienta saldo. Pārbaudiet jautājumā norādīto summu un klientu un noklikšķiniet uz “Clear” – visa summa tiek iegrāmatota klienta saldo, un ieraksts tiek atzīmēts kā nokārtots.",
          "prerequisites": "Ierakstam jābūt maksātājam, un tas vēl nedrīkst būt nokārtots.",
          "aliases": [
            "nokārtot uz klienta saldo",
            "negatīvs ieraksts",
            "atmaksa klientam",
            "klienta bilance",
            "rādīt negatīvās summas",
            "negativa summa"
          ]
        }
      }
    },
    {
      "id": "BNK-008",
      "area": "bank-statements",
      "job": "Delete a wrongly imported bank statement",
      "description": "Click \"Delete bank statement\" (the bin icon) in the statement's Options column, write a comment and click \"Delete\". The comment is required for imported statements and optional for manually entered ones. The statement is removed together with all its entries, and every clearance made from those entries is reversed; there is no undo in the app, but the same file can then be imported again.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "remove bank statement",
        "delete statement",
        "wrong file imported",
        "undo import",
        "delete imported statement",
        "reimport bank statement",
        "imported twice"
      ],
      "anchor": "bank-statements-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Ištrinti klaidingai importuotą banko išrašą",
          "description": "Išrašo stulpelyje „Nustatymai“ spauskite „Ištrinti banko įšrašą“ (šiukšliadėžės piktograma), parašykite komentarą ir spauskite „Ištrinti“. Importuotiems išrašams komentaras privalomas, ranka įvestiems – ne. Išrašas pašalinamas su visais įrašais, o visi iš jų atlikti užskaitymai atšaukiami; programoje to atšaukti negalima, bet tą patį failą vėliau galima importuoti iš naujo.",
          "aliases": [
            "ištrinti banko išrašą",
            "istrinti israsa",
            "pašalinti išrašą",
            "klaidingas failas",
            "atšaukti importą",
            "importuoti iš naujo"
          ]
        },
        "lv": {
          "job": "Dzēst kļūdaini importētu bankas izrakstu",
          "description": "Izraksta kolonnā “Options” noklikšķiniet uz “Delete bank statement” (miskastes ikona), ierakstiet komentāru un noklikšķiniet uz “Delete”. Importētiem izrakstiem komentārs ir obligāts, manuāli ievadītiem – nav. Izraksts tiek noņemts kopā ar visiem ierakstiem, un visas no tiem veiktās nokārtošanas tiek atceltas; lietotnē to atsaukt nevar, taču to pašu failu pēc tam var importēt vēlreiz.",
          "aliases": [
            "dzēst bankas izrakstu",
            "dzest izrakstu",
            "noņemt izrakstu",
            "kļūdains fails",
            "atcelt importu",
            "importēt vēlreiz"
          ]
        }
      }
    },
    {
      "id": "BNK-009",
      "area": "bank-statements",
      "job": "Delete a single entry from a bank statement",
      "description": "Tick the statement, then click \"Delete bank statement entry\" (the bin icon) on the entry, optionally write a comment and click \"Delete\". This is possible only on manually entered statements; entries of an imported statement cannot be deleted one by one — delete the whole statement instead, or hide the entry. If the entry was already cleared, its clearance is reversed.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The statement must have been entered manually.",
      "aliases": [
        "delete bank entry",
        "remove payment from statement",
        "delete statement line",
        "remove entry",
        "delete wrong payment line",
        "cannot delete entry"
      ],
      "anchor": "bank-statements-entries-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Ištrinti vieną banko išrašo įrašą",
          "description": "Pažymėkite išrašą, įraše spauskite „Ištrinti banko išrašo įrašą“ (šiukšliadėžės piktograma), jei norite, parašykite komentarą ir spauskite „Ištrinti“. Tai galima tik ranka įvestuose išrašuose; importuoto išrašo įrašų po vieną ištrinti negalima – ištrinkite visą išrašą arba paslėpkite įrašą. Jei įrašas jau buvo užskaitytas, jo užskaitymas atšaukiamas.",
          "prerequisites": "Išrašas turi būti įvestas ranka.",
          "aliases": [
            "ištrinti įrašą",
            "istrinti banko irasa",
            "pašalinti mokėjimą iš išrašo",
            "negaliu ištrinti įrašo",
            "ištrinti eilutę"
          ]
        },
        "lv": {
          "job": "Dzēst vienu bankas izraksta ierakstu",
          "description": "Atzīmējiet izrakstu, ierakstā noklikšķiniet uz “Delete bank statement entry” (miskastes ikona), ja vēlaties, ierakstiet komentāru un noklikšķiniet uz “Delete”. Tas iespējams tikai manuāli ievadītiem izrakstiem; importēta izraksta ierakstus nevar dzēst pa vienam – dzēsiet visu izrakstu vai paslēpiet ierakstu. Ja ieraksts jau bija nokārtots, tā nokārtošana tiek atcelta.",
          "prerequisites": "Izrakstam jābūt ievadītam manuāli.",
          "aliases": [
            "dzēst ierakstu",
            "dzest bankas ierakstu",
            "noņemt maksājumu no izraksta",
            "nevar dzēst ierakstu",
            "dzēst rindu"
          ]
        }
      }
    },
    {
      "id": "BNK-010",
      "area": "bank-statements",
      "job": "Hide an entry or show hidden entries again",
      "description": "Tick the statement, then click the eye button on the entry to hide it; it disappears from the entries list and the change is saved at once. To see hidden entries again, tick \"Include hidden entries\" below the entries list and click the eye button once more to unhide one. \"Include negative amounts\" next to it does the same for outgoing payments, which are not shown by default.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "hide entry",
        "show hidden entries",
        "unhide entry",
        "entry disappeared",
        "missing bank entry",
        "include hidden entries",
        "hide payment line"
      ],
      "anchor": "bank-statements-entry-filters",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Paslėpti įrašą arba vėl rodyti paslėptus įrašus",
          "description": "Pažymėkite išrašą ir įraše spauskite akies mygtuką, kad jį paslėptumėte; jis dingsta iš įrašų sąrašo, o pakeitimas išsaugomas iš karto. Norėdami vėl matyti paslėptus įrašus, po įrašų sąrašu pažymėkite „Įtraukti paslėptus įrašus“ ir dar kartą spauskite akies mygtuką, kad įrašą atslėptumėte. Šalia esantis „Įtraukti neigiamas sumas“ taip pat parodo išeinančius mokėjimus, kurie pagal nutylėjimą nerodomi.",
          "aliases": [
            "paslėpti įrašą",
            "rodyti paslėptus įrašus",
            "dingo įrašas",
            "paslepti irasa",
            "trūksta įrašo"
          ]
        },
        "lv": {
          "job": "Paslēpt ierakstu vai atkal rādīt paslēptos ierakstus",
          "description": "Atzīmējiet izrakstu un ierakstā noklikšķiniet uz acs pogas, lai to paslēptu; tas pazūd no ierakstu saraksta, un izmaiņa tiek saglabāta uzreiz. Lai atkal redzētu paslēptos ierakstus, zem ierakstu saraksta atzīmējiet “Iekļaut paslēptos ierakstus” un vēlreiz noklikšķiniet uz acs pogas, lai ierakstu parādītu. Blakus esošais “Iekļaut negatīvās summas” tāpat parāda izejošos maksājumus, kas pēc noklusējuma nav redzami.",
          "aliases": [
            "paslēpt ierakstu",
            "rādīt paslēptos ierakstus",
            "ieraksts pazuda",
            "paslept ierakstu",
            "trūkst ieraksta"
          ]
        }
      }
    },
    {
      "id": "BNK-011",
      "area": "bank-statements",
      "job": "See how a bank entry was cleared",
      "description": "Tick the statement, then click \"Clearance information\" (the i icon) on a cleared entry. The dialog lists every payment created by the clearance — policy, client, insurer, reminder, dates and premium amount — and below it \"Cleared\" compares their total with the entry amount, while \"Moved To client balance\" shows the part that went to the client balance. \"Export Excel\" saves the list.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/bankStatements",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The entry must be cleared. Outgoing payments to insurers have no clearance information.",
      "aliases": [
        "clearance information",
        "which policies were paid",
        "where did the payment go",
        "cleared payments list",
        "check clearance",
        "moved to client balance",
        "export clearance to excel"
      ],
      "anchor": "bank-statements-entries-grid",
      "source_ref": "help:BankStatements",
      "i18n": {
        "lt": {
          "job": "Pažiūrėti, kaip užskaitytas banko įrašas",
          "description": "Pažymėkite išrašą ir užskaitytame įraše spauskite „Užskaitymo informacija“ (i piktograma). Lange rodomi visi užskaitymo metu sukurti mokėjimai – polisas, klientas, draudikas, priminimas, datos ir įmokos suma, – o po jais „Cleared“ palygina jų sumą su įrašo suma, „Moved To client balance“ rodo dalį, kuri atiteko kliento balansui. „Export Excel“ išsaugo sąrašą.",
          "prerequisites": "Įrašas turi būti užskaitytas. Mokėjimams draudikams užskaitymo informacijos nėra.",
          "aliases": [
            "užskaitymo informacija",
            "uzskaitymo informacija",
            "kokie polisai apmokėti",
            "kur nuėjo mokėjimas",
            "patikrinti užskaitymą"
          ]
        },
        "lv": {
          "job": "Apskatīt, kā bankas ieraksts tika nokārtots",
          "description": "Atzīmējiet izrakstu un nokārtotā ierakstā noklikšķiniet uz “Clearance information” (i ikona). Logā redzami visi nokārtošanas laikā izveidotie maksājumi – polise, klients, apdrošinātājs, atgādinājums, datumi un prēmijas summa, – bet zem tiem “Cleared” salīdzina to kopsummu ar ieraksta summu, un “Moved To client balance” rāda daļu, kas nonāca klienta saldo. “Export Excel” saglabā sarakstu.",
          "prerequisites": "Ierakstam jābūt nokārtotam. Maksājumiem apdrošinātājiem nokārtošanas informācijas nav.",
          "aliases": [
            "nokārtošanas informācija",
            "nokartosanas informacija",
            "kuras polises apmaksātas",
            "kur aizgāja maksājums",
            "pārbaudīt nokārtošanu"
          ]
        }
      }
    },
    {
      "id": "CLB-001",
      "area": "client-balance",
      "job": "Find a client's balance",
      "description": "Open Client balance and type in the search box at the top: it filters the list by client name or number, company, currency, balance amount or last modified date (dd.mm.yyyy). A client has one row per GrECo company and currency, and rows with a zero balance stay hidden until you tick \"Show zero balance clients\". If the client is missing, check that its company is ticked in the company menu at the top right; clients outside your permission groups are not listed at all.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "client saldo",
        "client balance",
        "find client balance",
        "search saldo",
        "how much money does the client have",
        "overpayment of a client",
        "unmatched money of a client",
        "client credit",
        "prepayment balance"
      ],
      "anchor": "client-balance-search",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Rasti kliento balansą",
          "description": "Atverkite \"Kliento balansas\" ir rašykite paieškos laukelyje viršuje: sąrašas filtruojamas pagal kliento pavadinimą ar numerį, įmonę, valiutą, balanso sumą arba paskutinio koregavimo datą (dd.mm.yyyy). Klientas turi po eilutę kiekvienai GrECo įmonei ir valiutai, o eilutės su nuliniu balansu paslėptos, kol nepažymite \"Rodyti nulinius balansus\". Jei kliento nėra, patikrinkite, ar jo įmonė pažymėta įmonių meniu viršuje dešinėje; klientai už jūsų teisių grupių ribų nerodomi.",
          "aliases": [
            "kliento saldo",
            "kliento balansas",
            "rasti kliento balansa",
            "kliento permoka",
            "nesusieti pinigai",
            "kliento avansas",
            "ieškoti balanso"
          ]
        },
        "lv": {
          "job": "Atrast klienta bilanci",
          "description": "Atveriet \"Client balance\" un rakstiet meklēšanas laukā augšā: saraksts tiek filtrēts pēc klienta nosaukuma vai numura, uzņēmuma, valūtas, bilances summas vai pēdējo izmaiņu datuma (dd.mm.yyyy). Klientam ir viena rinda katram GrECo uzņēmumam un valūtai, un rindas ar nulles bilanci ir paslēptas, līdz atzīmējat \"Show zero balance clients\". Ja klienta nav, pārbaudiet, vai tā uzņēmums ir atzīmēts uzņēmumu izvēlnē augšā pa labi; klienti ārpus jūsu tiesību grupām netiek rādīti.",
          "aliases": [
            "klienta saldo",
            "klienta bilance",
            "atrast klienta bilanci",
            "klienta pārmaksa",
            "nesasaistīta nauda",
            "klienta avanss",
            "meklēt bilanci"
          ]
        }
      }
    },
    {
      "id": "CLB-002",
      "area": "client-balance",
      "job": "Show clients whose balance is zero",
      "description": "Tick \"Show zero balance clients\" next to the search box. Rows whose balance is 0 (to two decimals) are hidden by default; with the box ticked they are listed too, for example to check a client whose money has already been used up. Changing the box clears any row selection.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "zero balance",
        "show zero saldo",
        "client missing from balance list",
        "hidden clients",
        "balance used up",
        "show all clients",
        "client with no money left"
      ],
      "anchor": "client-balance-zero-toggle",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Rodyti klientus su nuliniu balansu",
          "description": "Pažymėkite \"Rodyti nulinius balansus\" šalia paieškos laukelio. Eilutės, kurių balansas lygus 0 (dviejų skaičių po kablelio tikslumu), pagal nutylėjimą paslėptos; pažymėjus jos taip pat rodomos, pvz., norint patikrinti klientą, kurio pinigai jau panaudoti. Pakeitus žymėjimą, pažymėtos eilutės atžymimos.",
          "aliases": [
            "nulinis balansas",
            "rodyti nulinius balansus",
            "nulinis saldo",
            "paslėpti klientai",
            "klientas nerodomas"
          ]
        },
        "lv": {
          "job": "Rādīt klientus ar nulles bilanci",
          "description": "Atzīmējiet \"Show zero balance clients\" blakus meklēšanas laukam. Rindas, kuru bilance ir 0 (ar divu zīmju precizitāti aiz komata), pēc noklusējuma ir paslēptas; ar atzīmi tās tiek rādītas arī, piemēram, lai pārbaudītu klientu, kura nauda jau izlietota. Mainot atzīmi, rindu atlase tiek noņemta.",
          "aliases": [
            "nulles bilance",
            "radit nulles bilances",
            "nulles saldo",
            "paslēpti klienti",
            "klients nav redzams"
          ]
        }
      }
    },
    {
      "id": "CLB-003",
      "area": "client-balance",
      "job": "Use a client's balance to pay outstanding premium",
      "description": "Find the client's row and click the split-arrow button \"Clear client balance\" at the end of it. The dialog loads the client's unpaid premium entries for that company and currency and already suggests amounts: the balance is spread over the entries in list order until it runs out. Adjust the \"To be cleared\" amounts (type them, or use the lightning and X buttons), set the payment date, then click \"Clear\". One payment is created for every row above 0, the dialog closes and the list reloads; the total may not exceed the balance and no row may exceed its debt.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The client must have a positive balance in that company and currency. Write access to PCT is needed; read-only users are refused by the server.",
      "aliases": [
        "clear client saldo",
        "clear client balance",
        "use overpayment for premium",
        "offset balance against premium",
        "pay premium from balance",
        "settle debt with saldo",
        "allocate prepayment",
        "match saldo to payment plan"
      ],
      "anchor": "client-balance-row-clear",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Panaudoti kliento balansą neapmokėtoms įmokoms",
          "description": "Raskite kliento eilutę ir jos gale spustelėkite mygtuką \"Užskaityti kliento balansą\" (išsišakojusi rodyklė). Langas įkelia neapmokėtas kliento įmokas toje įmonėje ir valiuta ir iš karto pasiūlo sumas: balansas paskirstomas įmokoms sąrašo tvarka, kol baigiasi. Pakoreguokite \"To be cleared\" sumas (įveskite arba naudokite žaibo ir X mygtukus), nustatykite mokėjimo datą ir spauskite \"Išvalyti\". Kiekvienai eilutei virš 0 sukuriamas mokėjimas, langas užsidaro ir sąrašas atnaujinamas; suma negali viršyti balanso, o eilutė – savo skolos.",
          "prerequisites": "Klientas turi turėti teigiamą balansą toje įmonėje ir valiuta. Reikia rašymo teisių PCT; vartotojams tik su skaitymo teisėmis serveris atsako.",
          "aliases": [
            "užskaityti kliento balansą",
            "uzskaityti saldo",
            "permoka įmokoms",
            "padengti skolą iš balanso",
            "kliento avanso panaudojimas",
            "užskaityti permoką"
          ]
        },
        "lv": {
          "job": "Izmantot klienta bilanci neapmaksātajām prēmijām",
          "description": "Atrodiet klienta rindu un tās beigās noklikšķiniet uz pogas \"Clear client balance\" (sazarota bulta). Logs ielādē klienta neapmaksātās prēmijas šajā uzņēmumā un valūtā un uzreiz piedāvā summas: bilance tiek sadalīta prēmijām saraksta secībā, līdz tā beidzas. Pielāgojiet \"To be cleared\" summas (ievadiet tās vai izmantojiet zibens un X pogas), iestatiet maksājuma datumu un spiediet \"Clear\". Katrai rindai virs 0 tiek izveidots maksājums, logs aizveras un saraksts tiek pārlādēts; kopsumma nedrīkst pārsniegt bilanci, un rinda nedrīkst pārsniegt savu parādu.",
          "prerequisites": "Klientam jābūt pozitīvai bilancei šajā uzņēmumā un valūtā. Nepieciešamas rakstīšanas tiesības PCT; lietotājiem tikai ar lasīšanas tiesībām serveris atsaka.",
          "aliases": [
            "ieskaitīt klienta bilanci",
            "ieskaitit saldo",
            "pārmaksa prēmijām",
            "segt parādu no bilances",
            "izmantot avansu",
            "nokārtot prēmiju no saldo"
          ]
        }
      }
    },
    {
      "id": "CLB-004",
      "area": "client-balance",
      "job": "Choose which premium entries the balance should pay",
      "description": "In \"Clear client balance\" use the filters on the left: booking date range (starts about three months back and ends 15 days ahead), clients, insurer country and insurers, payers, payment reference numbers (reminder numbers), service segments, policy numbers and subnumbers. Then click \"Search\": the matching unpaid entries reload and the suggested amounts are recalculated, replacing anything you typed. You can add other clients, for example a related company, so this balance also pays their premium. The currency is fixed to the currency of the balance.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Open the dialog from the split-arrow button on the client's row first. At least one client must be selected or Search stays disabled.",
      "aliases": [
        "filter clearance entries",
        "premium entry missing in clearance",
        "older premium not shown",
        "pay premium of another client from saldo",
        "clear only one policy",
        "clear by reminder number",
        "widen date range in clearance"
      ],
      "anchor": "client-balance-row-clear",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Pasirinkti, kurias įmokas apmokės balansas",
          "description": "Lange \"Užskaityti kliento balansą\" naudokite filtrus kairėje: užregistravimo datos intervalą (pradžioje maždaug trys mėnesiai atgal ir 15 dienų į priekį), klientus, draudiko šalį ir draudikus, mokėtojus, mokėjimo numerius (priminimų numerius), paslaugų segmentus, polisų numerius ir subnumerius. Tada spauskite \"Ieškoti\": atitinkančios neapmokėtos įmokos įkeliamos iš naujo, siūlomos sumos perskaičiuojamos, o jūsų įvestos pakeičiamos. Galite pridėti kitų klientų, pvz., susijusios įmonės, kad šis balansas apmokėtų ir jų įmokas. Valiuta visada lieka balanso valiuta.",
          "prerequisites": "Pirmiausia atverkite langą mygtuku su išsišakojusia rodykle kliento eilutėje. Turi būti pasirinktas bent vienas klientas, kitaip mygtukas Ieškoti neaktyvus.",
          "aliases": [
            "filtruoti įmokas užskaitymui",
            "trūksta įmokos",
            "senesnė įmoka nerodoma",
            "apmokėti kito kliento įmoką",
            "užskaityti vieną polisą",
            "pagal priminimo numerį"
          ]
        },
        "lv": {
          "job": "Izvēlēties, kuras prēmijas bilance apmaksās",
          "description": "Logā \"Clear client balance\" izmantojiet filtrus kreisajā pusē: grāmatošanas datuma periodu (sākumā aptuveni trīs mēneši atpakaļ un 15 dienas uz priekšu), klientus, apdrošinātāja valsti un apdrošinātājus, maksātājus, maksājuma atsauces numurus (atgādinājumu numurus), pakalpojumu segmentus, polišu numurus un apakšnumurus. Tad spiediet \"Search\": atbilstošās neapmaksātās prēmijas tiek ielādētas no jauna, ieteiktās summas pārrēķinātas un jūsu ievadītās aizstātas. Varat pievienot citus klientus, piemēram, saistītu uzņēmumu, lai šī bilance apmaksātu arī viņu prēmijas. Valūta vienmēr ir bilances valūta.",
          "prerequisites": "Vispirms atveriet logu ar sazarotās bultas pogu klienta rindā. Jābūt izvēlētam vismaz vienam klientam, citādi poga Search nav aktīva.",
          "aliases": [
            "filtrēt prēmijas ieskaitīšanai",
            "trūkst prēmijas",
            "vecāka prēmija nav redzama",
            "apmaksāt cita klienta prēmiju",
            "ieskaitīt vienu polisi",
            "pēc atgādinājuma numura"
          ]
        }
      }
    },
    {
      "id": "CLB-005",
      "area": "client-balance",
      "job": "Fix a balance clearance that cannot be saved",
      "description": "\"Clear\" stays disabled while the \"To be cleared\" total (shown in red) is higher than the balance, or when no entries are listed; lower some amounts or click Search. A payment date in the future stops the save with \"Payment date too late\", while a date more than a month back only warns. The server refuses the whole clearance if an amount is above the entry's debt, the entry is already paid, or the entry is outside the chosen clients, currency, insurers, payers, service segments or company. Filling rows marked with Ctrl or Shift uses the full balance, so recheck the total.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "clear button disabled",
        "cannot clear saldo",
        "clearance error",
        "total is red",
        "payment date too late",
        "payment date too early",
        "entry cannot be overpaid",
        "already paid error"
      ],
      "anchor": "client-balance-row-clear",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Išspręsti, kodėl balanso užskaitymo neįmanoma išsaugoti",
          "description": "\"Išvalyti\" lieka neaktyvus, kol \"To be cleared\" suma (rodoma raudonai) viršija balansą arba kai sąraše nėra įmokų; sumažinkite sumas arba spauskite \"Ieškoti\". Ateities mokėjimo data sustabdo išsaugojimą pranešimu \"Payment date too late\", o data, ankstesnė nei prieš mėnesį, tik įspėja. Serveris atmeta visą užskaitymą, jei suma viršija įmokos skolą, įmoka jau apmokėta arba nepatenka į pasirinktus klientus, valiutą, draudikus, mokėtojus, paslaugų segmentus ar įmonę. Su Ctrl ar Shift pažymėtų eilučių užpildymas naudoja visą balansą, todėl patikrinkite bendrą sumą.",
          "aliases": [
            "išvalyti neaktyvus",
            "negaliu užskaityti saldo",
            "užskaitymo klaida",
            "suma raudona",
            "mokėjimo data per vėlu",
            "įmoka jau apmokėta"
          ]
        },
        "lv": {
          "job": "Novērst, kāpēc bilances ieskaitīšanu nevar saglabāt",
          "description": "\"Clear\" paliek neaktīva, kamēr \"To be cleared\" kopsumma (sarkanā krāsā) pārsniedz bilanci vai sarakstā nav ierakstu; samaziniet summas vai spiediet \"Search\". Nākotnes maksājuma datums aptur saglabāšanu ar \"Payment date too late\", bet datums, kas ir vairāk nekā mēnesi senāks, tikai brīdina. Serveris noraida visu ieskaitīšanu, ja summa pārsniedz ieraksta parādu, ieraksts jau apmaksāts vai neatbilst izvēlētajiem klientiem, valūtai, apdrošinātājiem, maksātājiem, pakalpojumu segmentiem vai uzņēmumam. Ar Ctrl vai Shift atzīmēto rindu aizpildīšana izmanto visu bilanci, tāpēc pārbaudiet kopsummu.",
          "aliases": [
            "clear poga neaktīva",
            "nevar ieskaitīt saldo",
            "ieskaitīšanas kļūda",
            "kopsumma sarkana",
            "maksājuma datums par vēlu",
            "prēmija jau apmaksāta"
          ]
        }
      }
    },
    {
      "id": "CLB-006",
      "area": "client-balance",
      "job": "Clear GrECo's own balance against discounts",
      "description": "Rows of GrECo's own balance open \"Clear client balance (discounts)\" from the split-arrow button. The clearance then pays discount debt instead of premium debt, so the amounts follow the \"Discount debt\" column. The dialog opens with no client and no entries: pick the clients, choose \"Broker premium collection\" (Yes for entries whose premium GrECo collects, No for all others, Select all for both) and click \"Search\" before setting the amounts and clicking \"Clear\".",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "discount clearance",
        "clear discounts",
        "greco discount balance",
        "broker discount saldo",
        "pay discount debt",
        "commission discount clearance"
      ],
      "anchor": "client-balance-row-clear",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Užskaityti paties GrECo balansą nuolaidoms",
          "description": "Paties GrECo balanso eilutės mygtukas su išsišakojusia rodykle atveria \"Užskaityti kliento balansą (discounts)\". Tada užskaitymas dengia neapmokėtas nuolaidas vietoje įmokų skolos, todėl sumos remiasi stulpeliu \"Neapmokėta nuolaida\". Langas atsidaro be kliento ir be įmokų: pasirinkite klientus, nustatykite \"Broker premium collection\" (Yes – įmokos, kurias renka GrECo, No – visos kitos, \"Pasirinkti viską\" – abi grupės) ir spauskite \"Ieškoti\", tada nustatykite sumas ir spauskite \"Išvalyti\".",
          "aliases": [
            "nuolaidų užskaitymas",
            "užskaityti nuolaidas",
            "greco nuolaidu balansas",
            "brokerio nuolaida",
            "neapmokėta nuolaida"
          ]
        },
        "lv": {
          "job": "Ieskaitīt paša GrECo bilanci atlaidēs",
          "description": "Paša GrECo bilances rindas sazarotās bultas poga atver \"Clear client balance (discounts)\". Tad ieskaitīšana sedz atlaižu parādu, nevis prēmiju parādu, tāpēc summas balstās uz kolonnu \"Discount debt\". Logs atveras bez klienta un bez ierakstiem: izvēlieties klientus, iestatiet \"Broker premium collection\" (Yes – prēmijas, kuras iekasē GrECo, No – visas pārējās, Select all – abas grupas) un spiediet \"Search\", pēc tam iestatiet summas un spiediet \"Clear\".",
          "aliases": [
            "atlaižu ieskaitīšana",
            "ieskaitīt atlaides",
            "greco atlaizu bilance",
            "brokera atlaide",
            "atlaižu parāds"
          ]
        }
      }
    },
    {
      "id": "CLB-007",
      "area": "client-balance",
      "job": "See how a client's balance built up and was used",
      "description": "Click the i button (\"Client balance information\") at the end of the client's row. \"Client balance clearance information\" lists every entry that changed this balance for that company and currency, newest first, with its amount and the \"Current balance\" right after it, plus the payment date, whether it came from a bank statement entry clearance, the statement date, the payment reference number, the account numbers and the comment. The dialog is read-only.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "saldo history",
        "balance history",
        "where does the balance come from",
        "client balance entries",
        "why does the client have a balance",
        "running balance",
        "saldo movements"
      ],
      "anchor": "client-balance-row-info",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Pažiūrėti, kaip susidarė ir buvo panaudotas kliento balansas",
          "description": "Spustelėkite mygtuką i (\"Kliento balanso informacija\") kliento eilutės gale. \"Client balance clearance information\" pateikia visus įrašus, keitusius šį balansą toje įmonėje ir valiuta, nuo naujausio, su suma ir iškart po jo buvusiu \"Current balance\", taip pat mokėjimo datą, ar įrašas atsirado užskaitant banko išrašo įrašą, išrašo datą, mokėjimo numerį, sąskaitų numerius ir komentarą. Langas skirtas tik skaityti.",
          "aliases": [
            "saldo istorija",
            "balanso istorija",
            "iš kur balansas",
            "kliento balanso įrašai",
            "balanso judėjimas",
            "is kur balansas"
          ]
        },
        "lv": {
          "job": "Redzēt, kā klienta bilance veidojusies un izlietota",
          "description": "Noklikšķiniet uz pogas i (\"Client balance information\") klienta rindas beigās. \"Client balance clearance information\" uzskaita visus ierakstus, kas mainījuši šo bilanci šajā uzņēmumā un valūtā, jaunākos vispirms, ar summu un \"Current balance\" uzreiz pēc tā, kā arī maksājuma datumu, vai ieraksts radies, ieskaitot bankas izraksta ierakstu, izraksta datumu, maksājuma atsauces numuru, kontu numurus un komentāru. Logs ir tikai lasāms.",
          "aliases": [
            "saldo vēsture",
            "bilances vēsture",
            "no kurienes bilance",
            "klienta bilances ieraksti",
            "bilances kustība",
            "bilances vesture"
          ]
        }
      }
    },
    {
      "id": "CLB-008",
      "area": "client-balance",
      "job": "See which payments a balance entry settled",
      "description": "Open the balance history with the i button on the client's row. Some negative entries carry their own i button at the end of the row: click it to list below \"Payments settled by this client balance entry\" with policy, insurer, amount and declaration date, and to highlight the entry. Click the same button again to hide the list. \"No data\" means the entry did not settle any payment.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "what did the saldo pay",
        "payments from client balance",
        "which policies were paid from balance",
        "settled payments of saldo entry",
        "trace balance usage"
      ],
      "anchor": "client-balance-row-info",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Pažiūrėti, kuriuos mokėjimus padengė balanso įrašas",
          "description": "Atverkite balanso istoriją mygtuku i kliento eilutėje. Kai kurių neigiamų įrašų eilutės gale yra atskiras mygtukas i: spustelėkite jį, kad žemiau būtų parodyti \"Šiuo kliento balanso įrašu padengti mokėjimai\" su polisu, draudiku, suma ir deklaravimo data, o įrašas paryškintas. Spustelėkite tą patį mygtuką dar kartą, kad sąrašą paslėptumėte. \"No data\" reiškia, kad įrašas nepadengė jokio mokėjimo.",
          "aliases": [
            "ką apmokėjo saldo",
            "mokėjimai iš balanso",
            "kurie polisai apmokėti iš balanso",
            "padengti mokėjimai",
            "ka apmokejo saldo"
          ]
        },
        "lv": {
          "job": "Redzēt, kurus maksājumus nokārtoja bilances ieraksts",
          "description": "Atveriet bilances vēsturi ar pogu i klienta rindā. Dažiem negatīviem ierakstiem rindas beigās ir sava poga i: noklikšķiniet uz tās, lai zemāk parādītu \"Maksājumi, kas nokārtoti ar šo klienta bilances ierakstu\" ar polisi, apdrošinātāju, summu un deklarēšanas datumu, un ieraksts tiktu izcelts. Noklikšķiniet uz tās pašas pogas vēlreiz, lai sarakstu paslēptu. \"No data\" nozīmē, ka ieraksts nav nokārtojis nevienu maksājumu.",
          "aliases": [
            "ko apmaksāja saldo",
            "maksājumi no bilances",
            "kuras polises apmaksātas no bilances",
            "nokārtotie maksājumi",
            "ko apmaksaja saldo"
          ]
        }
      }
    },
    {
      "id": "CLB-009",
      "area": "client-balance",
      "job": "Export a client's balance history to Excel",
      "description": "Open the balance history with the i button on the client's row and click \"Export Excel\" to download the client balance entries. When the payments settled by one entry are open below, a second button \"Export payments to Excel\" downloads that list. The buttons only appear when the list has rows. To export the client balance list itself, use \"Export Excel\" next to the search box.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "export saldo to excel",
        "download balance history",
        "excel of client balance",
        "saldo report",
        "export balance entries"
      ],
      "anchor": "client-balance-row-info",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Eksportuoti kliento balanso istoriją į Excel",
          "description": "Atverkite balanso istoriją mygtuku i kliento eilutėje ir spauskite \"Export Excel\", kad atsisiųstumėte kliento balanso įrašus. Kai žemiau atverti vieno įrašo padengti mokėjimai, antrasis mygtukas \"Eksportuoti mokėjimus į Excel\" atsisiunčia tą sąrašą. Mygtukai rodomi tik tada, kai sąraše yra eilučių. Patį klientų balansų sąrašą eksportuokite mygtuku \"Export Excel\" šalia paieškos laukelio.",
          "aliases": [
            "eksportuoti saldo į excel",
            "atsisiųsti balanso istoriją",
            "kliento balansas excel",
            "saldo ataskaita",
            "eksportuoti saldo i excel"
          ]
        },
        "lv": {
          "job": "Eksportēt klienta bilances vēsturi uz Excel",
          "description": "Atveriet bilances vēsturi ar pogu i klienta rindā un spiediet \"Export Excel\", lai lejupielādētu klienta bilances ierakstus. Kad zemāk atvērti viena ieraksta nokārtotie maksājumi, otrā poga \"Eksportēt maksājumus uz Excel\" lejupielādē šo sarakstu. Pogas parādās tikai tad, ja sarakstā ir rindas. Pašu klientu bilanču sarakstu eksportējiet ar pogu \"Export Excel\" blakus meklēšanas laukam.",
          "aliases": [
            "eksportēt saldo uz excel",
            "lejupielādēt bilances vēsturi",
            "klienta bilance excel",
            "saldo atskaite",
            "eksportet saldo uz excel"
          ]
        }
      }
    },
    {
      "id": "CLB-010",
      "area": "client-balance",
      "job": "Choose which GrECo companies' balances are shown",
      "description": "Click the company button at the top right to open the list of GrECo companies you have access to, and tick the companies you need; at least one must stay ticked. The client balances reload when the menu closes, and only balances booked in the ticked companies are listed.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "change company",
        "select greco company",
        "show lithuanian company",
        "show latvian company",
        "company filter",
        "balances of other company"
      ],
      "anchor": "client-balance-companies",
      "anchor_action": "open",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Pasirinkti, kurių GrECo įmonių balansai rodomi",
          "description": "Spustelėkite įmonės mygtuką viršuje dešinėje, kad atvertumėte jums prieinamų GrECo įmonių sąrašą, ir pažymėkite reikiamas įmones; bent viena turi likti pažymėta. Uždarius meniu klientų balansai įkeliami iš naujo ir rodomi tik pažymėtose įmonėse užregistruoti balansai.",
          "aliases": [
            "pakeisti įmonę",
            "pasirinkti greco imone",
            "įmonės filtras",
            "kitos įmonės balansai"
          ]
        },
        "lv": {
          "job": "Izvēlēties, kuru GrECo uzņēmumu bilances rādīt",
          "description": "Noklikšķiniet uz uzņēmuma pogas augšā pa labi, lai atvērtu jums pieejamo GrECo uzņēmumu sarakstu, un atzīmējiet vajadzīgos uzņēmumus; vismaz vienam jāpaliek atzīmētam. Aizverot izvēlni, klientu bilances tiek ielādētas no jauna un redzamas tikai atzīmētajos uzņēmumos iegrāmatotās bilances.",
          "aliases": [
            "mainīt uzņēmumu",
            "izvēlēties greco uznemumu",
            "uzņēmuma filtrs",
            "cita uzņēmuma bilances"
          ]
        }
      }
    },
    {
      "id": "CLB-011",
      "area": "client-balance",
      "job": "Refresh the client balances after other work",
      "description": "The client balance list never updates by itself. Click the refresh button (circular arrow) next to the page icons to fetch the balances again, for example after clearing bank statements or after a colleague cleared a balance. A clearance saved on this page reloads the list automatically.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "reload balances",
        "balance not updated",
        "saldo still shows old amount",
        "refresh saldo",
        "new overpayment not visible",
        "update client balance list"
      ],
      "anchor": "client-balance-refresh",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Atnaujinti klientų balansus po kito darbo",
          "description": "Klientų balansų sąrašas pats neatsinaujina. Spustelėkite atnaujinimo mygtuką (apskrita rodyklė) šalia puslapių piktogramų, kad balansai būtų įkelti iš naujo, pvz., užskaitę banko išrašus arba kai kolega užskaitė balansą. Šiame puslapyje išsaugojus užskaitymą sąrašas atnaujinamas automatiškai.",
          "aliases": [
            "atnaujinti balansus",
            "balansas neatsinaujino",
            "saldo rodo seną sumą",
            "perkrauti saldo",
            "nauja permoka nematoma",
            "atnaujinti saldo"
          ]
        },
        "lv": {
          "job": "Atjaunot klientu bilances pēc cita darba",
          "description": "Klientu bilanču saraksts pats neatjaunojas. Noklikšķiniet uz atjaunošanas pogas (apaļa bulta) blakus lapu ikonām, lai bilances ielādētu no jauna, piemēram, pēc bankas izrakstu ieskaitīšanas vai kad kolēģis ieskaitījis bilanci. Saglabājot ieskaitīšanu šajā lapā, saraksts tiek pārlādēts automātiski.",
          "aliases": [
            "pārlādēt bilances",
            "bilance nav atjaunota",
            "saldo rāda veco summu",
            "atjaunot saldo",
            "jaunā pārmaksa nav redzama",
            "parladet bilances"
          ]
        }
      }
    },
    {
      "id": "CLB-012",
      "area": "client-balance",
      "job": "Export the client balance list to Excel",
      "description": "\"Export Excel\" next to the search box on Client balance downloads the balances the list shows right now — client, company, currency, balance and last modified date. The search text and the \"show zero balances\" switch apply to the file too, so filter the list first if you only need some clients. The button is disabled while the list is loading.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/clientBalance",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "export client balances",
        "download all client balances",
        "client balance list excel",
        "saldo list to excel",
        "overpayments to excel",
        "export all saldos"
      ],
      "anchor": "client-balance-export-excel",
      "source_ref": "help:ClientBalance",
      "i18n": {
        "lt": {
          "job": "Eksportuoti klientų balansų sąrašą į Excel",
          "description": "Mygtukas \"Export Excel\" šalia paieškos laukelio puslapyje „Kliento balansas“ atsisiunčia balansus, kurie šiuo metu rodomi sąraše — klientą, įmonę, valiutą, balansą ir paskutinio koregavimo datą. Paieškos tekstas ir nulinių balansų jungiklis taikomi ir failui, todėl, jei reikia tik dalies klientų, pirmiausia atfiltruokite sąrašą. Kol sąrašas įkeliamas, mygtukas neaktyvus.",
          "aliases": [
            "eksportuoti klientų balansus",
            "visų klientų saldo excel",
            "balansų sąrašas excel",
            "eksportuoti visus saldo",
            "eksportuoti klientu balansus"
          ]
        },
        "lv": {
          "job": "Eksportēt klientu bilanču sarakstu uz Excel",
          "description": "Poga \"Export Excel\" blakus meklēšanas laukam lapā \"Client balance\" lejupielādē bilances, kas pašlaik redzamas sarakstā — klientu, uzņēmumu, valūtu, bilanci un pēdējo izmaiņu datumu. Meklēšanas teksts un nulles bilanču slēdzis attiecas arī uz failu, tāpēc, ja vajag tikai daļu klientu, vispirms atfiltrējiet sarakstu. Kamēr saraksts ielādējas, poga nav aktīva.",
          "aliases": [
            "eksportēt klientu bilances",
            "visu klientu saldo excel",
            "bilanču saraksts excel",
            "eksportēt visus saldo",
            "eksportet klientu bilances"
          ]
        }
      }
    },
    {
      "id": "INS-001",
      "area": "insurer-reports",
      "job": "Import an insurer report Excel file",
      "description": "Click \"Add insurer report\", then \"Import insurer report\". Pick the insurer, the GrECo company, the currency and the year and month the report covers, add the .xlsx file and click \"Import\"; every report number in the file becomes its own report and its entries are matched to the installments and payments in PCT automatically. If a report number in the file already exists for that insurer, all reports from the earlier file are deleted and replaced by the new file.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT and access to the GrECo company. The first sheet needs the columns Insurer report no, Client code, Client name, Policy number, Commission percentage, Premium amount, Commission amount, Commission type and Report net.",
      "aliases": [
        "upload insurer report",
        "load insurer excel",
        "insurer commission report",
        "import insurer statement",
        "insurer premium report",
        "add insurer report",
        "upload report from insurer",
        "insurer bordereau"
      ],
      "anchor": "insurer-reports-import-menu-item",
      "anchor_surface": "insurer-reports-add-menu",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Importuoti draudiko ataskaitos Excel failą",
          "description": "Spustelėkite „Pridėti draudiko ataskaitą“, tada „Importuoti draudiko ataskaitą“. Pasirinkite draudiką, GrECo įmonę, valiutą, ataskaitos metus ir mėnesį, pridėkite .xlsx failą ir spustelėkite „Importuoti“; kiekvienas failo ataskaitos numeris tampa atskira ataskaita, o jos įrašai automatiškai susiejami su PCT įmokomis ir mokėjimais. Jei failo ataskaitos numeris tam draudikui jau egzistuoja, visos ankstesnio failo ataskaitos ištrinamos ir pakeičiamos nauju failu.",
          "prerequisites": "Rašymo teisės PCT ir prieiga prie GrECo įmonės. Pirmame lape turi būti stulpeliai Insurer report no, Client code, Client name, Policy number, Commission percentage, Premium amount, Commission amount, Commission type ir Report net.",
          "aliases": [
            "įkelti draudiko ataskaitą",
            "importuoti draudiko ataskaita",
            "draudiko excel",
            "draudiko ataskaitos failas",
            "ikelti draudiko ataskaita",
            "komisinių ataskaita"
          ]
        },
        "lv": {
          "job": "Importēt apdrošinātāja atskaites Excel failu",
          "description": "Noklikšķiniet “Pievienot apdrošinātāja atskaiti”, pēc tam “Importēt apdrošinātāja atskaiti”. Izvēlieties apdrošinātāju, GrECo uzņēmumu, valūtu, atskaites gadu un mēnesi, pievienojiet .xlsx failu un noklikšķiniet “Import”; katrs faila atskaites numurs kļūst par atsevišķu atskaiti, un tās ieraksti automātiski tiek sasaistīti ar PCT iemaksām un maksājumiem. Ja faila atskaites numurs šim apdrošinātājam jau pastāv, visas iepriekšējā faila atskaites tiek dzēstas un aizstātas ar jauno failu.",
          "prerequisites": "Rakstīšanas tiesības PCT un piekļuve GrECo uzņēmumam. Pirmajā lapā jābūt kolonnām Insurer report no, Client code, Client name, Policy number, Commission percentage, Premium amount, Commission amount, Commission type un Report net.",
          "aliases": [
            "augšupielādēt apdrošinātāja atskaiti",
            "importēt apdrošinātāja atskaiti",
            "apdrosinataja atskaite excel",
            "apdrošinātāja fails",
            "ielādēt atskaiti",
            "komisijas atskaite"
          ]
        }
      }
    },
    {
      "id": "INS-002",
      "area": "insurer-reports",
      "job": "Check the entries of an insurer report",
      "description": "Tick the checkbox at the start of a report row; its entries open in the lower grid. The first columns hold the insurer figures, the \"(PP)\" columns the matched installment and \"Premium (P)\" the matched payment; a red cell means the insurer value differs from PCT, and orange rows were matched automatically. Untick \"Include perfect matches\" to see only the entries that still need attention.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "open insurer report",
        "see report entries",
        "review insurer report",
        "compare insurer report with pct",
        "red cells insurer report",
        "differences between insurer and payment plan",
        "report details"
      ],
      "anchor": "insurer-reports-grid",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Peržiūrėti draudiko ataskaitos įrašus",
          "description": "Pažymėkite langelį ataskaitos eilutės pradžioje – jos įrašai atsidaro apatinėje lentelėje. Pirmuose stulpeliuose – draudiko duomenys, „(mokėjimo planas)“ stulpeliuose – susieta įmoka, o „Įmokos suma (mokėjimas)“ – susietas mokėjimas; raudonas langelis reiškia, kad draudiko reikšmė skiriasi nuo PCT, o oranžinės eilutės susietos automatiškai. Nuimkite žymę „Įtraukti tobulus atitikmenis“, kad matytumėte tik dėmesio reikalaujančius įrašus.",
          "aliases": [
            "atidaryti draudiko ataskaitą",
            "ataskaitos įrašai",
            "ataskaitos irasai",
            "palyginti su PCT",
            "raudoni langeliai",
            "skirtumai ataskaitoje"
          ]
        },
        "lv": {
          "job": "Pārbaudīt apdrošinātāja atskaites ierakstus",
          "description": "Atzīmējiet rūtiņu atskaites rindas sākumā – tās ieraksti atveras apakšējā tabulā. Pirmajās kolonnās ir apdrošinātāja dati, kolonnās “(maksājumu plāns)” – sasaistītā iemaksa, bet “Prēmijas summa (maksājums)” – sasaistītais maksājums; sarkana šūna nozīmē, ka apdrošinātāja vērtība atšķiras no PCT, un oranžās rindas sasaistītas automātiski. Noņemiet atzīmi “Iekļaut ideālās atbilstības”, lai redzētu tikai ierakstus, kam vajadzīga uzmanība.",
          "aliases": [
            "atvērt apdrošinātāja atskaiti",
            "atskaites ieraksti",
            "salīdzināt ar PCT",
            "sarkanās šūnas",
            "atskaites atšķirības",
            "atskaites ieraksti apskatit"
          ]
        }
      }
    },
    {
      "id": "INS-003",
      "area": "insurer-reports",
      "job": "Match an insurer report entry by hand",
      "description": "Select the report, then click the link icon in the last column of the unmatched entry. Choose \"Payment plan entry\" (installment) or \"Payment\", search (for a payment enter the exact policy number) and click \"Match\"; only installments and payments of the same insurer and GrECo company as the report are offered. Choosing a payment links its installment too, and a payment already linked to another entry is refused.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT.",
      "aliases": [
        "link entry to payment",
        "manual match insurer entry",
        "assign installment to insurer entry",
        "unmatched entry",
        "connect report line to payment plan",
        "fix unmatched entries",
        "link policy to report"
      ],
      "anchor": "insurer-reports-entry-match",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Susieti draudiko ataskaitos įrašą ranka",
          "description": "Pasirinkite ataskaitą, tada paskutiniame nesusieto įrašo stulpelyje spustelėkite nuorodos piktogramą. Pasirinkite „Mokėjimo plano įrašas“ (įmoka) arba „Mokėjimas“, ieškokite (mokėjimui įveskite tikslų poliso numerį) ir spustelėkite „Susieti“; siūlomos tik to paties draudiko ir GrECo įmonės kaip ataskaitos įmokos ir mokėjimai. Pasirinkus mokėjimą kartu susiejama ir jo įmoka, o mokėjimas, jau susietas su kitu įrašu, atmetamas.",
          "prerequisites": "Rašymo teisės PCT.",
          "aliases": [
            "susieti įrašą ranka",
            "susieti irasa su mokejimu",
            "nesusietas įrašas",
            "priskirti įmoką",
            "rankinis susiejimas"
          ]
        },
        "lv": {
          "job": "Manuāli sasaistīt apdrošinātāja atskaites ierakstu",
          "description": "Izvēlieties atskaiti, pēc tam nesasaistītā ieraksta pēdējā kolonnā noklikšķiniet saites ikonu. Izvēlieties “Maksājumu plāna ieraksts” (iemaksa) vai “Maksājums”, meklējiet (maksājumam ievadiet precīzu polises numuru) un noklikšķiniet “Sasaistīt”; tiek piedāvātas tikai tā paša apdrošinātāja un GrECo uzņēmuma iemaksas un maksājumi kā atskaitei. Izvēloties maksājumu, tiek sasaistīta arī tā iemaksa, un maksājums, kas jau sasaistīts ar citu ierakstu, tiek noraidīts.",
          "prerequisites": "Rakstīšanas tiesības PCT.",
          "aliases": [
            "sasaistīt ierakstu manuāli",
            "sasaistit ar maksajumu",
            "nesasaistīts ieraksts",
            "piesaistīt iemaksu",
            "manuāla sasaiste"
          ]
        }
      }
    },
    {
      "id": "INS-004",
      "area": "insurer-reports",
      "job": "Remove a wrong match from an entry",
      "description": "Select the report and click the unmatch icon in the last column of the matched entry. The link to the installment and payment is removed at once, without a confirmation, and the report counts update. To link the entry to something else instead, use the re-match icon next to it, which opens the match dialog.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT.",
      "aliases": [
        "unmatch entry",
        "unlink payment from insurer report",
        "wrong match",
        "undo match",
        "change match of entry",
        "detach installment"
      ],
      "anchor": "insurer-reports-entry-unmatch",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Pašalinti klaidingą įrašo susiejimą",
          "description": "Pasirinkite ataskaitą ir paskutiniame susieto įrašo stulpelyje spustelėkite atsiejimo piktogramą. Ryšys su įmoka ir mokėjimu pašalinamas iš karto, be patvirtinimo, o ataskaitos skaičiai atsinaujina. Jei įrašą norite susieti su kuo nors kitu, naudokite šalia esančią pakartotinio susiejimo piktogramą, kuri atidaro susiejimo langą.",
          "prerequisites": "Rašymo teisės PCT.",
          "aliases": [
            "atsieti įrašą",
            "atsieti irasa",
            "klaidingas susiejimas",
            "atšaukti susiejimą",
            "pakeisti susiejimą"
          ]
        },
        "lv": {
          "job": "Noņemt nepareizu ieraksta sasaisti",
          "description": "Izvēlieties atskaiti un sasaistītā ieraksta pēdējā kolonnā noklikšķiniet atsaistīšanas ikonu. Saite ar iemaksu un maksājumu tiek noņemta uzreiz, bez apstiprinājuma, un atskaites skaitītāji atjaunojas. Ja ierakstu vēlaties sasaistīt ar ko citu, izmantojiet blakus esošo atkārtotas sasaistes ikonu, kas atver sasaistes logu.",
          "prerequisites": "Rakstīšanas tiesības PCT.",
          "aliases": [
            "atsaistīt ierakstu",
            "atsaistit ierakstu",
            "nepareiza sasaiste",
            "atcelt sasaisti",
            "mainīt sasaisti"
          ]
        }
      }
    },
    {
      "id": "INS-005",
      "area": "insurer-reports",
      "job": "Run the automatic matching again for a report",
      "description": "Click the re-match icon in the last column of the report row and confirm with \"Re-match\". Every entry is first unlinked and then matched again by the automatic rules, so entries you matched by hand can be overwritten. Use it after the missing installments or payments have been added in PCT.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT.",
      "aliases": [
        "rematch insurer report",
        "re-run matching",
        "match report again",
        "refresh matching",
        "automatic matching again",
        "rematch all entries"
      ],
      "anchor": "insurer-reports-row-rematch",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Iš naujo automatiškai susieti ataskaitą",
          "description": "Paskutiniame ataskaitos eilutės stulpelyje spustelėkite pakartotinio susiejimo piktogramą ir patvirtinkite „Susieti iš naujo“. Visi įrašai pirmiausia atsiejami, o tada vėl susiejami pagal automatines taisykles, todėl ranka susieti įrašai gali būti perrašyti. Naudokite, kai PCT jau papildyta trūkstamomis įmokomis ar mokėjimais.",
          "prerequisites": "Rašymo teisės PCT.",
          "aliases": [
            "susieti iš naujo",
            "susieti is naujo",
            "pakartotinis susiejimas",
            "automatinis susiejimas",
            "perskaičiuoti susiejimą"
          ]
        },
        "lv": {
          "job": "Atkārtoti automātiski sasaistīt atskaiti",
          "description": "Atskaites rindas pēdējā kolonnā noklikšķiniet atkārtotas sasaistes ikonu un apstipriniet ar “Sasaistīt atkārtoti”. Visi ieraksti vispirms tiek atsaistīti un pēc tam atkal sasaistīti pēc automātiskajiem noteikumiem, tāpēc manuāli sasaistītie ieraksti var tikt pārrakstīti. Izmantojiet to pēc tam, kad PCT ir pievienotas trūkstošās iemaksas vai maksājumi.",
          "prerequisites": "Rakstīšanas tiesības PCT.",
          "aliases": [
            "sasaistīt atkārtoti",
            "sasaistit atkartoti",
            "atkārtota sasaiste",
            "automātiskā sasaiste",
            "pārrēķināt sasaisti"
          ]
        }
      }
    },
    {
      "id": "INS-006",
      "area": "insurer-reports",
      "job": "Delete a wrongly imported insurer report",
      "description": "Click the delete icon in the last column of the report row and confirm with \"Delete\". Every report imported from the same Excel file is deleted together with its entries, and the installments and payments they were linked to become free again. There is no undo on the page; import the file again if needed. To replace a report with a corrected file you can also simply import the new file.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT.",
      "aliases": [
        "remove insurer report",
        "delete imported report",
        "wrong insurer file",
        "undo import",
        "delete insurer excel",
        "remove report from wrong insurer",
        "replace report with corrected file",
        "get rid of old insurer report",
        "insurer sent a new version of the report"
      ],
      "anchor": "insurer-reports-row-delete",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Ištrinti klaidingai importuotą draudiko ataskaitą",
          "description": "Paskutiniame ataskaitos eilutės stulpelyje spustelėkite ištrynimo piktogramą ir patvirtinkite „Ištrinti“. Kartu su įrašais ištrinamos visos iš to paties Excel failo importuotos ataskaitos, o su jomis susietos įmokos ir mokėjimai vėl tampa laisvi. Puslapyje atšaukti negalima – prireikus importuokite failą iš naujo. Norėdami ataskaitą pakeisti pataisytu failu, galite tiesiog importuoti naują failą.",
          "prerequisites": "Rašymo teisės PCT.",
          "aliases": [
            "ištrinti draudiko ataskaitą",
            "istrinti ataskaita",
            "pašalinti ataskaitą",
            "klaidingas failas",
            "atšaukti importą"
          ]
        },
        "lv": {
          "job": "Dzēst kļūdaini importētu apdrošinātāja atskaiti",
          "description": "Atskaites rindas pēdējā kolonnā noklikšķiniet dzēšanas ikonu un apstipriniet ar “Delete”. Kopā ar ierakstiem tiek dzēstas visas no tā paša Excel faila importētās atskaites, un ar tām sasaistītās iemaksas un maksājumi atkal kļūst brīvi. Lapā darbību atsaukt nevar – vajadzības gadījumā importējiet failu vēlreiz. Lai atskaiti aizstātu ar labotu failu, varat vienkārši importēt jauno failu.",
          "prerequisites": "Rakstīšanas tiesības PCT.",
          "aliases": [
            "dzēst apdrošinātāja atskaiti",
            "dzest atskaiti",
            "noņemt atskaiti",
            "kļūdains fails",
            "atcelt importu"
          ]
        }
      }
    },
    {
      "id": "INS-007",
      "area": "insurer-reports",
      "job": "Find the reports of an insurer for a period",
      "description": "Pick the insurer in \"Search insurers\" and set the from and to dates; the list reloads from the server. The dates filter on \"Insurer report date\" (the month-end chosen at import) unless you switch the date field to \"Insurer report created at\" (the day of the import). The page opens with the last three months, so widen the dates for older reports, then narrow the list with the search box.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "filter insurer reports",
        "search insurer report number",
        "reports of one insurer",
        "insurer reports last month",
        "find old insurer report",
        "report not in the list",
        "filter by report date"
      ],
      "anchor": "insurer-reports-insurer-filter",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Rasti draudiko ataskaitas už laikotarpį",
          "description": "Lauke „Pasirinkti draudiką“ pasirinkite draudiką ir nustatykite datas nuo ir iki – sąrašas iš naujo įkeliamas iš serverio. Datos filtruoja pagal „Draudiko ataskaitos data“ (importuojant pasirinktą mėnesio pabaigą), nebent datos lauką perjungsite į „Draudiko ataskaita sukurta“ (importo diena). Puslapis atidaromas su paskutiniais trimis mėnesiais, todėl senesnėms ataskaitoms išplėskite datas, o tada susiaurinkite sąrašą paieškos laukeliu.",
          "aliases": [
            "filtruoti draudiko ataskaitas",
            "rasti ataskaitą",
            "draudiko ataskaitos pagal datą",
            "ataskaitos nera sarase",
            "ieškoti ataskaitos numerio"
          ]
        },
        "lv": {
          "job": "Atrast apdrošinātāja atskaites par periodu",
          "description": "Laukā “Search insurers” izvēlieties apdrošinātāju un iestatiet datumus no un līdz – saraksts tiek pārlādēts no servera. Datumi filtrē pēc “Apdrošinātāja atskaites datums” (importējot izvēlētās mēneša beigas), ja vien datuma lauku nepārslēdzat uz “Apdrošinātāja atskaite izveidota” (importa diena). Lapa atveras ar pēdējiem trim mēnešiem, tāpēc vecākām atskaitēm paplašiniet datumus un pēc tam sašauriniet sarakstu ar meklēšanas lauku.",
          "aliases": [
            "filtrēt apdrošinātāja atskaites",
            "atrast atskaiti",
            "atskaites pēc datuma",
            "atskaites nav saraksta",
            "meklēt atskaites numuru"
          ]
        }
      }
    },
    {
      "id": "INS-008",
      "area": "insurer-reports",
      "job": "Check whether a report was paid to the insurer",
      "description": "Look at \"Insurer report payment date\" and \"Insurer report payment amount\" in the report row. They are taken from the latest outgoing bank statement entry to that insurer whose payment reference is the insurer report number, and stay empty until such a bank statement is imported. Compare the amount with the \"Report net\" sum of the report.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The bank statement with the payment to the insurer must be imported on the Bank statements page.",
      "aliases": [
        "was insurer report paid",
        "payment to insurer",
        "insurer report payment date",
        "paid amount to insurer",
        "report net not paid",
        "transfer to insurer",
        "settlement with insurer"
      ],
      "anchor": "insurer-reports-grid",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Patikrinti, ar ataskaita apmokėta draudikui",
          "description": "Ataskaitos eilutėje žiūrėkite „Draudiko ataskaitos mokėjimo data“ ir „Draudiko ataskaitos mokėjimo suma“. Jos imamos iš paskutinio išeinančio banko išrašo įrašo tam draudikui, kurio mokėjimo paskirtis yra draudiko ataskaitos numeris, ir lieka tuščios, kol toks banko išrašas neimportuotas. Palyginkite sumą su ataskaitos „Ataskaitos neto“ suma.",
          "prerequisites": "Banko išrašas su mokėjimu draudikui turi būti importuotas puslapyje „Banko išrašai“.",
          "aliases": [
            "ar apmokėta ataskaita",
            "mokėjimas draudikui",
            "ataskaitos mokejimo data",
            "sumokėta draudikui",
            "pervedimas draudikui",
            "ar sumokėjome draudikui",
            "ar sumokejome draudikui",
            "ataskaita jau apmokėta",
            "mokėjimas pagal draudiko ataskaitą"
          ]
        },
        "lv": {
          "job": "Pārbaudīt, vai atskaite apmaksāta apdrošinātājam",
          "description": "Atskaites rindā skatiet “Apdrošinātāja atskaites maksājuma datums” un “Apdrošinātāja atskaites maksājuma summa”. Tie tiek ņemti no pēdējā izejošā bankas izraksta ieraksta šim apdrošinātājam, kura maksājuma mērķis ir apdrošinātāja atskaites numurs, un paliek tukši, kamēr šāds bankas izraksts nav importēts. Salīdziniet summu ar atskaites “Atskaites neto” summu.",
          "prerequisites": "Bankas izrakstam ar maksājumu apdrošinātājam jābūt importētam lapā “Bankas konta izraksti”.",
          "aliases": [
            "vai atskaite apmaksāta",
            "maksājums apdrošinātājam",
            "atskaites maksajuma datums",
            "samaksāts apdrošinātājam",
            "pārskaitījums apdrošinātājam"
          ]
        }
      }
    },
    {
      "id": "INS-009",
      "area": "insurer-reports",
      "job": "Export insurer report entries to Excel",
      "description": "Select the report, set the entry search and the \"Include perfect matches\" checkbox as you need, then click \"Export Excel\". The workbook holds exactly the entries the lower grid shows, with the report number as the first column, and cells that are red in the grid are marked in the file too. The button is disabled while no entry is visible.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "download insurer report entries",
        "excel export of differences",
        "export unmatched entries",
        "save report to excel",
        "export insurer comparison",
        "send differences to insurer"
      ],
      "anchor": "insurer-reports-export-excel",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Eksportuoti draudiko ataskaitos įrašus į Excel",
          "description": "Pasirinkite ataskaitą, pagal poreikį nustatykite įrašų paiešką ir žymimąjį langelį „Įtraukti tobulus atitikmenis“, tada spustelėkite „Export Excel“. Faile yra lygiai tie įrašai, kuriuos rodo apatinė lentelė, pirmame stulpelyje – ataskaitos numeris, o lentelėje raudoni langeliai pažymimi ir faile. Mygtukas neaktyvus, kol nematomas nė vienas įrašas.",
          "aliases": [
            "eksportuoti įrašus",
            "eksportuoti i excel",
            "atsisiųsti skirtumus",
            "nesusieti įrašai excel",
            "ataskaita į excel"
          ]
        },
        "lv": {
          "job": "Eksportēt apdrošinātāja atskaites ierakstus uz Excel",
          "description": "Izvēlieties atskaiti, pēc vajadzības iestatiet ierakstu meklēšanu un izvēles rūtiņu “Iekļaut ideālās atbilstības”, pēc tam noklikšķiniet “Export Excel”. Failā ir tieši tie ieraksti, ko rāda apakšējā tabula, pirmajā kolonnā ir atskaites numurs, un tabulā sarkanās šūnas tiek atzīmētas arī failā. Poga nav aktīva, kamēr nav redzams neviens ieraksts.",
          "aliases": [
            "eksportēt ierakstus",
            "eksportet uz excel",
            "lejupielādēt atšķirības",
            "nesasaistītie ieraksti excel",
            "atskaite uz excel"
          ]
        }
      }
    },
    {
      "id": "INS-010",
      "area": "insurer-reports",
      "job": "Download the original insurer report file",
      "description": "Click the download icon in the last column of the report row. It opens the Excel file exactly as it was imported, from the PCT archive; all reports that came from the same file share it. The link is time-limited, so refresh the page if the download stops working.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "get original insurer file",
        "download imported excel",
        "open insurer excel",
        "see file from insurer",
        "original report attachment"
      ],
      "anchor": "insurer-reports-row-download",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Atsisiųsti originalų draudiko ataskaitos failą",
          "description": "Paskutiniame ataskaitos eilutės stulpelyje spustelėkite atsisiuntimo piktogramą. Ji atidaro Excel failą iš PCT archyvo tokį, koks buvo importuotas; visos iš to paties failo gautos ataskaitos turi tą patį failą. Nuoroda galioja ribotą laiką, todėl jei atsisiuntimas nebeveikia, atnaujinkite puslapį.",
          "aliases": [
            "atsisiųsti originalų failą",
            "atsisiusti draudiko faila",
            "importuotas excel",
            "draudiko failas"
          ]
        },
        "lv": {
          "job": "Lejupielādēt sākotnējo apdrošinātāja atskaites failu",
          "description": "Atskaites rindas pēdējā kolonnā noklikšķiniet lejupielādes ikonu. Tā atver Excel failu no PCT arhīva tieši tādu, kāds tas tika importēts; visām no tā paša faila iegūtajām atskaitēm ir viens un tas pats fails. Saite ir derīga ierobežotu laiku, tāpēc, ja lejupielāde vairs nedarbojas, atsvaidziniet lapu.",
          "aliases": [
            "lejupielādēt sākotnējo failu",
            "lejupieladet apdrosinataja failu",
            "importētais excel",
            "apdrošinātāja fails"
          ]
        }
      }
    },
    {
      "id": "INS-011",
      "area": "insurer-reports",
      "job": "See which payment an entry is matched to",
      "description": "Select the report and click the info icon in the last column of a matched entry. A read-only dialog shows the linked payment, or the installment when the entry has no payment: client, policy, insurer, premium, commission and booking date, plus the premium period and remaining debt of an installment, or the payment date and declaration date of a payment.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "matched payment details",
        "what is the entry linked to",
        "view matched installment",
        "why is the cell red",
        "show linked payment plan entry"
      ],
      "anchor": "insurer-reports-entry-view",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Pamatyti, su kuriuo mokėjimu susietas įrašas",
          "description": "Pasirinkite ataskaitą ir paskutiniame susieto įrašo stulpelyje spustelėkite informacijos piktogramą. Tik peržiūrai skirtame lange rodomas susietas mokėjimas arba, jei mokėjimo nėra, įmoka: klientas, polisas, draudikas, įmoka, komisiniai ir apskaitos data, taip pat įmokos laikotarpis ir likusi skola arba mokėjimo ir deklaravimo data.",
          "aliases": [
            "susieto mokėjimo informacija",
            "su kuo susietas įrašas",
            "susieta įmoka",
            "kodel raudonas langelis"
          ]
        },
        "lv": {
          "job": "Redzēt, ar kuru maksājumu ieraksts sasaistīts",
          "description": "Izvēlieties atskaiti un sasaistītā ieraksta pēdējā kolonnā noklikšķiniet informācijas ikonu. Tikai lasāmā logā redzams sasaistītais maksājums vai, ja maksājuma nav, iemaksa: klients, polise, apdrošinātājs, prēmija, komisija un grāmatošanas datums, kā arī iemaksas periods un atlikušais parāds vai maksājuma un deklarēšanas datums.",
          "aliases": [
            "sasaistītā maksājuma informācija",
            "ar ko sasaistīts ieraksts",
            "sasaistītā iemaksa",
            "kapec sarkana suna"
          ]
        }
      }
    },
    {
      "id": "INS-012",
      "area": "insurer-reports",
      "job": "Show only the entries that still need work",
      "description": "Select the report and untick \"Include perfect matches\" below the entry grid. The orange rows that were matched automatically disappear, leaving unmatched entries and entries matched by hand; the choice is remembered in this browser. A red \"Unmatched entries\" count in the report row tells you how many entries are still without a link.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/insurerReports",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "hide perfect matches",
        "show unmatched entries only",
        "hide orange rows",
        "entries without match",
        "only problems in insurer report",
        "open items insurer report"
      ],
      "anchor": "insurer-reports-perfect-matches",
      "source_ref": "help:InsurerReports",
      "i18n": {
        "lt": {
          "job": "Rodyti tik įrašus, kuriems reikia veiksmų",
          "description": "Pasirinkite ataskaitą ir po įrašų lentele nuimkite žymę „Įtraukti tobulus atitikmenis“. Automatiškai susietos oranžinės eilutės dingsta, lieka nesusieti ir ranka susieti įrašai; pasirinkimas įsimenamas šioje naršyklėje. Raudonas „Nesutapę įrašai“ skaičius ataskaitos eilutėje rodo, kiek įrašų dar nesusieta.",
          "aliases": [
            "paslėpti tobulus atitikmenis",
            "tik nesusieti įrašai",
            "paslepti oranzines eilutes",
            "nesutapę įrašai"
          ]
        },
        "lv": {
          "job": "Rādīt tikai ierakstus, kam vajadzīga rīcība",
          "description": "Izvēlieties atskaiti un zem ierakstu tabulas noņemiet atzīmi “Iekļaut ideālās atbilstības”. Automātiski sasaistītās oranžās rindas pazūd, paliek nesasaistītie un manuāli sasaistītie ieraksti; izvēle tiek atcerēta šajā pārlūkprogrammā. Sarkans “Nesaskaņotie ieraksti” skaits atskaites rindā rāda, cik ierakstu vēl nav sasaistīti.",
          "aliases": [
            "paslēpt ideālās atbilstības",
            "tikai nesasaistītie ieraksti",
            "paslept oranzas rindas",
            "nesaskaņotie ieraksti"
          ]
        }
      }
    },
    {
      "id": "PAY-001",
      "area": "payments",
      "job": "Find the payments cleared for one insurer and period",
      "description": "On Payments, set the period with the two dates and choose in the list next to them which date they compare (Payment date, Cleared date, Booking date, Declared date or Insurer report date). Then pick the insurer under \"Search insurers\" and, if needed, the client, the full policy number, the service segment, the currency and the payment type; every change reloads the list. Declared payments are hidden by default, and the search box only narrows the rows already loaded.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "cleared payments for insurer",
        "payments by insurer",
        "list of payments",
        "filter payments by date",
        "which premiums were paid this month",
        "collected premium for insurer",
        "payments per period",
        "find a payment by policy number"
      ],
      "anchor": "payments-insurer",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Rasti draudiko mokėjimus už laikotarpį",
          "description": "Puslapyje „Mokėjimai“ nustatykite laikotarpį dviem datomis ir šalia esančiame sąraše pasirinkite, kuri data lyginama („Mokėjimo data“, „Užskaityta“, „Įmokos data“, „Deklaruota“ ar „Draudiko ataskaitos data“). Tada lauke „Pasirinkti draudiką“ pasirinkite draudiką ir, jei reikia, klientą, visą poliso numerį, draudimo liniją, valiutą ir mokėjimo tipą; kiekvienas pakeitimas iš naujo įkelia sąrašą. Deklaruoti mokėjimai pagal nutylėjimą slepiami, o paieškos laukas tik susiaurina jau įkeltas eilutes.",
          "aliases": [
            "draudiko mokėjimai",
            "mokėjimai pagal draudiką",
            "užskaityti mokėjimai",
            "mokejimai uz laikotarpi",
            "surinktos įmokos",
            "mokėjimų sąrašas",
            "rasti mokejima pagal poliso numeri"
          ]
        },
        "lv": {
          "job": "Atrast apdrošinātāja maksājumus par periodu",
          "description": "Lapā \"Payments\" iestatiet periodu ar diviem datumiem un blakus esošajā sarakstā izvēlieties, kuru datumu salīdzināt (\"Payment date\", \"Cleared date\", \"Booking date\", \"Declared date\" vai \"Apdrošinātāja atskaites datums\"). Tad laukā \"Search insurers\" izvēlieties apdrošinātāju un, ja vajag, klientu, pilnu polises numuru, segmentu, valūtu un maksājuma veidu; katra izmaiņa pārlādē sarakstu. Deklarētie maksājumi pēc noklusējuma ir paslēpti, un meklēšanas lauks tikai sašaurina jau ielādētās rindas.",
          "aliases": [
            "apdrošinātāja maksājumi",
            "maksājumi pēc apdrošinātāja",
            "piesaistītie maksājumi",
            "maksajumi par periodu",
            "iekasētās prēmijas",
            "maksājumu saraksts"
          ]
        }
      }
    },
    {
      "id": "PAY-002",
      "area": "payments",
      "job": "Declare collected payments to the insurer",
      "description": "Choose the insurer in the Insurer filter, tick the payments, check that the small button inside \"Declare payments\" shows the robot (automatic), then click \"Declare payments\"; with several GrECo companies selected, pick the company. In the dialog check the \"To be declared\" amounts and click \"Declare payments\" at the bottom: the payments are sent to the insurer API and only the lines the insurer accepted are marked declared. Automatic declaration exists only for the Sagauta company and some insurers; otherwise the response says it is not implemented and nothing is marked.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write permission in PCT (the limited role is refused). An insurer must be chosen and at least one payment ticked.",
      "aliases": [
        "declare payments",
        "declare premium to insurer",
        "send payments to insurer",
        "report collected premium",
        "premium declaration",
        "declaration via api",
        "sagauta declaration",
        "submit payments to insurer",
        "send collected premium to insurer",
        "monthly premium declaration to insurer"
      ],
      "anchor": "payments-declare-submit",
      "anchor_surface": "payments-declare-button",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Deklaruoti surinktus mokėjimus draudikui",
          "description": "Filtre „Draudikas“ pasirinkite draudiką, pažymėkite mokėjimus, patikrinkite, kad mažas mygtukas mygtuke „Deklaruoti įmokas“ rodo robotą (automatinis režimas), ir spustelėkite „Deklaruoti įmokas“; jei pasirinktos kelios GrECo įmonės, pasirinkite įmonę. Lange patikrinkite sumas stulpelyje „To be declared“ ir apačioje spustelėkite „Deklaruoti įmokas“: mokėjimai siunčiami į draudiko API, o deklaruotais pažymimos tik draudiko priimtos eilutės. Automatinis deklaravimas veikia tik įmonei Sagauta ir kai kuriems draudikams; kitu atveju atsakyme nurodoma, kad funkcija neįgyvendinta, ir niekas nepažymima.",
          "prerequisites": "Rašymo teisė PCT (ribotos rolės naudotojams atsisakoma). Turi būti pasirinktas draudikas ir pažymėtas bent vienas mokėjimas.",
          "aliases": [
            "deklaruoti įmokas",
            "deklaruoti mokejimus",
            "įmokų deklaravimas draudikui",
            "siųsti mokėjimus draudikui",
            "deklaravimas per api",
            "sagauta deklaracija"
          ]
        },
        "lv": {
          "job": "Deklarēt iekasētos maksājumus apdrošinātājam",
          "description": "Filtrā \"Insurer\" izvēlieties apdrošinātāju, atzīmējiet maksājumus, pārbaudiet, ka mazā poga pogā \"Declare payments\" rāda robotu (automātiskais režīms), un noklikšķiniet \"Declare payments\"; ja izvēlēti vairāki GrECo uzņēmumi, izvēlieties uzņēmumu. Logā pārbaudiet summas kolonnā \"To be declared\" un apakšā noklikšķiniet \"Declare payments\": maksājumi tiek nosūtīti uz apdrošinātāja API, un par deklarētām tiek atzīmētas tikai pieņemtās rindas. Automātiskā deklarēšana darbojas tikai uzņēmumam Sagauta un dažiem apdrošinātājiem; citādi atbildē teikts, ka tā nav ieviesta, un nekas netiek atzīmēts.",
          "prerequisites": "Rakstīšanas tiesības PCT (ierobežotās lomas lietotājiem tiek atteikts). Jābūt izvēlētam apdrošinātājam un atzīmētam vismaz vienam maksājumam.",
          "aliases": [
            "deklarēt maksājumus",
            "deklaret premijas apdrosinatajam",
            "nosūtīt maksājumus apdrošinātājam",
            "prēmiju deklarēšana",
            "deklarēšana caur api"
          ]
        }
      }
    },
    {
      "id": "PAY-003",
      "area": "payments",
      "job": "Mark payments as declared manually",
      "description": "Use this when the payments were already reported to the insurer outside PCT. Choose the insurer, tick the payments, click the small robot button inside \"Declare payments\" so it shows a hand (manual), then open \"Declare payments\" and confirm with \"Declare payments\" in the dialog. PCT sends nothing to the insurer; it only records the payments as declared manually and never overwrites a payment already declared through the insurer API. Manual declaration is available only for the Sagauta company.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write permission in PCT (the limited role is refused). An insurer must be chosen and at least one payment ticked.",
      "aliases": [
        "manual declaration",
        "declared outside pct",
        "mark as declared",
        "set payments declared",
        "manual payment declaration",
        "flag payments as reported to insurer"
      ],
      "anchor": "payments-declare-mode",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Pažymėti mokėjimus kaip deklaruotus rankiniu būdu",
          "description": "Naudokite, kai mokėjimai jau pranešti draudikui ne per PCT. Pasirinkite draudiką, pažymėkite mokėjimus, spustelėkite mažą roboto mygtuką mygtuke „Deklaruoti įmokas“, kad jis rodytų ranką („Manual payment declaration“), tada atidarykite „Deklaruoti įmokas“ ir lange patvirtinkite mygtuku „Deklaruoti įmokas“. PCT draudikui nieko nesiunčia, tik užfiksuoja mokėjimus kaip deklaruotus rankiniu būdu ir niekada neperrašo per draudiko API jau deklaruoto mokėjimo. Rankinis deklaravimas galimas tik įmonei Sagauta.",
          "prerequisites": "Rašymo teisė PCT (ribotos rolės naudotojams atsisakoma). Turi būti pasirinktas draudikas ir pažymėtas bent vienas mokėjimas.",
          "aliases": [
            "rankinis deklaravimas",
            "pazymeti kaip deklaruota",
            "deklaruota ne per pct",
            "rankiniu budu deklaruoti"
          ]
        },
        "lv": {
          "job": "Atzīmēt maksājumus kā deklarētus manuāli",
          "description": "Izmantojiet, ja maksājumi jau ir paziņoti apdrošinātājam ārpus PCT. Izvēlieties apdrošinātāju, atzīmējiet maksājumus, noklikšķiniet mazo robota pogu pogā \"Declare payments\", lai tā rādītu roku (\"Manual payment declaration\"), tad atveriet \"Declare payments\" un logā apstipriniet ar \"Declare payments\". PCT apdrošinātājam neko nesūta, tikai reģistrē maksājumus kā manuāli deklarētus un nekad nepārraksta maksājumu, kas jau deklarēts caur apdrošinātāja API. Manuālā deklarēšana pieejama tikai uzņēmumam Sagauta.",
          "prerequisites": "Rakstīšanas tiesības PCT (ierobežotās lomas lietotājiem tiek atteikts). Jābūt izvēlētam apdrošinātājam un atzīmētam vismaz vienam maksājumam.",
          "aliases": [
            "manuāla deklarēšana",
            "atzimet ka deklaretu",
            "deklarēts ārpus pct",
            "manuali deklaret"
          ]
        }
      }
    },
    {
      "id": "PAY-004",
      "area": "payments",
      "job": "Generate the Excel report for an insurer",
      "description": "Choose the insurer, tick the payments, click \"Declare payments\" and, in the dialog, click \"Generate report\"; when it finishes, \"Download report\" opens the Excel file in a new tab. Generating the report also marks every payment in it as declared, so do it only when you really send the report. It works for insurers with a report template (several Lithuanian insurers, and any insurer for GrECo Latvia); otherwise the error says the excel format is not defined for the chosen insurer.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write permission in PCT (the limited role is refused). An insurer must be chosen and at least one payment ticked.",
      "aliases": [
        "insurer report",
        "excel report for insurer",
        "premium report for insurer",
        "generate report",
        "download insurer excel",
        "monthly report to insurer",
        "collected premium excel",
        "bordereau"
      ],
      "anchor": "payments-generate-report",
      "anchor_surface": "payments-declare-button",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Sugeneruoti draudiko Excel ataskaitą",
          "description": "Pasirinkite draudiką, pažymėkite mokėjimus, spustelėkite „Deklaruoti įmokas“ ir lange spustelėkite „Generate report“; kai baigiama, „Download report“ atidaro Excel failą naujame skirtuke. Sugeneravus ataskaitą visi joje esantys mokėjimai pažymimi kaip deklaruoti, todėl darykite tai tik tada, kai tikrai siunčiate ataskaitą. Veikia draudikams su ataskaitos šablonu (keliems Lietuvos draudikams ir bet kuriam GrECo Latvijos draudikui); kitu atveju klaida praneša, kad pasirinktam draudikui Excel formatas neapibrėžtas.",
          "prerequisites": "Rašymo teisė PCT (ribotos rolės naudotojams atsisakoma). Turi būti pasirinktas draudikas ir pažymėtas bent vienas mokėjimas.",
          "aliases": [
            "draudiko ataskaita",
            "excel ataskaita draudikui",
            "generuoti ataskaita",
            "atsisiųsti draudiko excel",
            "įmokų ataskaita draudikui"
          ]
        },
        "lv": {
          "job": "Ģenerēt Excel atskaiti apdrošinātājam",
          "description": "Izvēlieties apdrošinātāju, atzīmējiet maksājumus, noklikšķiniet \"Declare payments\" un logā noklikšķiniet \"Generate report\"; kad tas pabeigts, \"Download report\" atver Excel failu jaunā cilnē. Ģenerējot atskaiti, visi tajā iekļautie maksājumi tiek atzīmēti kā deklarēti, tāpēc dariet to tikai tad, kad tiešām sūtāt atskaiti. Darbojas apdrošinātājiem ar atskaites veidni (vairākiem Lietuvas apdrošinātājiem un jebkuram GrECo Latvijas apdrošinātājam); citādi kļūda ziņo, ka izvēlētajam apdrošinātājam Excel formāts nav definēts.",
          "prerequisites": "Rakstīšanas tiesības PCT (ierobežotās lomas lietotājiem tiek atteikts). Jābūt izvēlētam apdrošinātājam un atzīmētam vismaz vienam maksājumam.",
          "aliases": [
            "apdrošinātāja atskaite",
            "excel atskaite apdrosinatajam",
            "ģenerēt atskaiti",
            "lejupielādēt atskaiti",
            "prēmiju atskaite apdrošinātājam"
          ]
        }
      }
    },
    {
      "id": "PAY-005",
      "area": "payments",
      "job": "Declare only part of a payment amount",
      "description": "In the \"Declare payments\" dialog the \"To be declared\" column starts with each payment's premium. Click a cell and type the amount to declare (a minus sign is ignored), use the cross icon to set a row to 0, or the lightning icon to fill it with what is still missing up to its premium; the header icons fill or clear all rows. The total under the grid compares what you declare with the premium total and turns red when you declare more. The amount you enter is what the insurer receives and what is stored as the declared premium.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "An insurer must be chosen and at least one payment ticked before the dialog opens.",
      "aliases": [
        "change declared amount",
        "partial declaration",
        "declare less than premium",
        "edit to be declared",
        "set declared amount to zero",
        "adjust amount before declaring",
        "split payment declaration"
      ],
      "anchor": "payments-declare-grid",
      "anchor_surface": "payments-declare-button",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Deklaruoti tik dalį mokėjimo sumos",
          "description": "Lange „Deklaruoti įmokas“ stulpelyje „To be declared“ iš pradžių rodoma kiekvieno mokėjimo įmoka. Spustelėkite langelį ir įveskite deklaruojamą sumą (minuso ženklas ignoruojamas), kryželio piktograma nustatykite eilutę į 0 arba žaibo piktograma užpildykite ją trūkstama suma iki jos įmokos; antraštės piktogramos užpildo arba išvalo visas eilutes. Suma po lentele lygina deklaruojamą sumą su įmokų suma ir tampa raudona, jei deklaruojate daugiau. Įvesta suma siunčiama draudikui ir išsaugoma kaip deklaruota įmoka.",
          "prerequisites": "Prieš atidarant langą turi būti pasirinktas draudikas ir pažymėtas bent vienas mokėjimas.",
          "aliases": [
            "pakeisti deklaruojamą sumą",
            "dalinis deklaravimas",
            "deklaruoti maziau nei imoka",
            "to be declared suma",
            "nustatyti suma i nuli"
          ]
        },
        "lv": {
          "job": "Deklarēt tikai daļu no maksājuma summas",
          "description": "Logā \"Declare payments\" kolonnā \"To be declared\" sākumā ir katra maksājuma prēmija. Noklikšķiniet uz šūnas un ievadiet deklarējamo summu (mīnusa zīme tiek ignorēta), ar krustiņa ikonu iestatiet rindu uz 0 vai ar zibens ikonu aizpildiet to ar trūkstošo summu līdz tās prēmijai; virsraksta ikonas aizpilda vai notīra visas rindas. Kopsumma zem tabulas salīdzina deklarējamo ar prēmiju kopsummu un kļūst sarkana, ja deklarējat vairāk. Ievadītā summa tiek nosūtīta apdrošinātājam un saglabāta kā deklarētā prēmija.",
          "prerequisites": "Pirms loga atvēršanas jābūt izvēlētam apdrošinātājam un atzīmētam vismaz vienam maksājumam.",
          "aliases": [
            "mainīt deklarējamo summu",
            "daļēja deklarēšana",
            "deklaret mazak par premiju",
            "to be declared summa",
            "iestatit summu uz nulli"
          ]
        }
      }
    },
    {
      "id": "PAY-006",
      "area": "payments",
      "job": "Undo a payment that was cleared by mistake",
      "description": "Find the payment on Payments (switch on declared payments if it was already declared) and tick it; an invalidate icon appears in the last column of every ticked row. Click it, add a comment explaining why and confirm with \"Invalidate\": all ticked payments are invalidated at once. The payment leaves the list, the comment is appended to it, any reminder it paid is reduced again, and if it came from a bank statement the money returns to the client balance so it can be cleared again.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write permission in PCT (the limited role is refused).",
      "aliases": [
        "invalidate payment",
        "reverse clearance",
        "cancel payment",
        "delete payment",
        "undo clearing",
        "wrong client cleared",
        "unclear a payment",
        "storno payment"
      ],
      "anchor": "payments-grid",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Atšaukti per klaidą užskaitytą mokėjimą",
          "description": "Raskite mokėjimą puslapyje „Mokėjimai“ (jei jis jau deklaruotas, įtraukite deklaruotus mokėjimus) ir jį pažymėkite; kiekvienos pažymėtos eilutės paskutiniame stulpelyje atsiranda panaikinimo piktograma. Spustelėkite ją, įrašykite komentarą su priežastimi ir patvirtinkite mygtuku „Invalidate“: visi pažymėti mokėjimai panaikinami iš karto. Mokėjimas dingsta iš sąrašo, komentaras pridedamas prie jo, apmokėto priminimo suma vėl sumažinama, o jei mokėjimas buvo iš banko išrašo, pinigai grįžta į kliento balansą ir juos galima užskaityti iš naujo.",
          "prerequisites": "Rašymo teisė PCT (ribotos rolės naudotojams atsisakoma).",
          "aliases": [
            "panaikinti mokėjimą",
            "atšaukti užskaitymą",
            "istrinti mokejima",
            "klaidingai uzskaitytas mokejimas",
            "atstatyti uzskaityma",
            "storno"
          ]
        },
        "lv": {
          "job": "Atcelt kļūdaini piesaistītu maksājumu",
          "description": "Atrodiet maksājumu lapā \"Payments\" (ja tas jau deklarēts, ieslēdziet deklarētos maksājumus) un atzīmējiet to; katras atzīmētās rindas pēdējā kolonnā parādās anulēšanas ikona. Noklikšķiniet to, ierakstiet komentāru ar iemeslu un apstipriniet ar \"Invalidate\": visi atzīmētie maksājumi tiek anulēti vienlaikus. Maksājums pazūd no saraksta, komentārs tiek tam pievienots, apmaksātā atgādinājuma summa atkal samazinās, un, ja maksājums bija no bankas konta izraksta, nauda atgriežas klienta bilancē, lai to varētu piesaistīt no jauna.",
          "prerequisites": "Rakstīšanas tiesības PCT (ierobežotās lomas lietotājiem tiek atteikts).",
          "aliases": [
            "anulēt maksājumu",
            "atcelt piesaisti",
            "dzēst maksājumu",
            "kļūdaini piesaistīts maksājums",
            "atsaukt maksajumu",
            "storno"
          ]
        }
      }
    },
    {
      "id": "PAY-007",
      "area": "payments",
      "job": "See which payments were already declared",
      "description": "Declared payments are hidden by default. Click the toggle button right after \"Declare payments\" to include them, then set the date-type list to \"Declared date\" to see what was declared in a period. Declared rows carry a person icon next to the tick box; hover it to see who declared the payment, when, and whether it was declared manually. A red \"Declared premium\" means a different amount was declared than the premium cleared.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "show declared payments",
        "include declared",
        "already declared payments",
        "who declared payment",
        "declaration history",
        "payments sent to insurer",
        "what was declared in a period"
      ],
      "anchor": "payments-exclude-declared",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Pamatyti, kurie mokėjimai jau deklaruoti",
          "description": "Deklaruoti mokėjimai pagal nutylėjimą slepiami. Spustelėkite jungiklio mygtuką iškart po „Deklaruoti įmokas“, kad juos įtrauktumėte, ir datos tipo sąraše pasirinkite „Deklaruota“, kad matytumėte, kas deklaruota per laikotarpį. Deklaruotose eilutėse šalia žymimojo langelio yra žmogaus piktograma; užvedę pelę pamatysite, kas ir kada deklaravo ir ar rankiniu būdu. Raudonas „Declared premium“ reiškia, kad deklaruota kita suma nei užskaityta įmoka.",
          "aliases": [
            "rodyti deklaruotus mokėjimus",
            "jau deklaruoti",
            "kas deklaravo",
            "deklaravimo istorija",
            "itraukti deklaruotas imokas"
          ]
        },
        "lv": {
          "job": "Redzēt, kuri maksājumi jau deklarēti",
          "description": "Deklarētie maksājumi pēc noklusējuma ir paslēpti. Noklikšķiniet slēdža pogu tieši aiz \"Declare payments\", lai tos iekļautu, un datuma veida sarakstā izvēlieties \"Declared date\", lai redzētu, kas deklarēts periodā. Deklarētajās rindās blakus izvēles rūtiņai ir cilvēka ikona; novietojot virs tās peli, redzams, kas un kad deklarēja un vai manuāli. Sarkans \"Declared premium\" nozīmē, ka deklarēta cita summa nekā piesaistītā prēmija.",
          "aliases": [
            "rādīt deklarētos maksājumus",
            "jau deklarēti",
            "kas deklarēja",
            "deklarēšanas vēsture",
            "ieklaut deklaretos"
          ]
        }
      }
    },
    {
      "id": "PAY-008",
      "area": "payments",
      "job": "Export the payment list to Excel",
      "description": "Set the filters first, then click \"Export Excel\" in the Payments toolbar. The file contains every loaded payment with all grid columns, and cells shown in red in the grid are marked in the file too. The search box is not applied to the export, so narrow the list with the filters if you need only part of it. This export changes nothing; it is not the insurer report and does not mark anything as declared.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "export payments",
        "download payments to excel",
        "payments xlsx",
        "excel export of cleared payments",
        "save payment list",
        "export to spreadsheet"
      ],
      "anchor": "payments-export-excel",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Eksportuoti mokėjimų sąrašą į Excel",
          "description": "Pirmiausia nustatykite filtrus, tada puslapio „Mokėjimai“ įrankių juostoje spustelėkite „Export Excel“. Faile yra visi įkelti mokėjimai su visais lentelės stulpeliais, o lentelėje raudoni langeliai pažymimi ir faile. Paieškos laukas eksportui netaikomas, todėl, jei reikia tik dalies, susiaurinkite sąrašą filtrais. Šis eksportas nieko nekeičia: tai ne draudiko ataskaita ir jis nieko nepažymi kaip deklaruoto.",
          "aliases": [
            "eksportuoti mokėjimus",
            "mokejimai i excel",
            "atsisiųsti mokėjimų sąrašą",
            "export excel mokejimai"
          ]
        },
        "lv": {
          "job": "Eksportēt maksājumu sarakstu uz Excel",
          "description": "Vispirms iestatiet filtrus, tad lapas \"Payments\" rīkjoslā noklikšķiniet \"Export Excel\". Failā ir visi ielādētie maksājumi ar visām tabulas kolonnām, un tabulā sarkanās šūnas tiek atzīmētas arī failā. Meklēšanas lauks eksportam netiek piemērots, tāpēc, ja vajag tikai daļu, sašauriniet sarakstu ar filtriem. Šis eksports neko nemaina: tā nav apdrošinātāja atskaite, un tas neko neatzīmē kā deklarētu.",
          "aliases": [
            "eksportēt maksājumus",
            "maksajumi uz excel",
            "lejupielādēt maksājumu sarakstu",
            "export excel maksajumi"
          ]
        }
      }
    },
    {
      "id": "PAY-009",
      "area": "payments",
      "job": "Spot payments that differ from the insurer report",
      "description": "On Payments, scroll the grid to the insurer report columns (report number, report date, insurer report premium, commission and commission rate). A red value means the linked insurer report states a different premium, commission or commission rate than PCT; a red \"Declared premium\" means the amount declared differs from the premium cleared. Set the date-type list to \"Insurer report date\" to look at one report period, and use \"Export Excel\" to get the same red marks in a file.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/payments",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "red amounts",
        "insurer report mismatch",
        "commission differs",
        "premium differs from insurer report",
        "reconcile with insurer report",
        "why is the amount red",
        "compare with insurer statement"
      ],
      "anchor": "payments-grid",
      "source_ref": "help:Payments",
      "i18n": {
        "lt": {
          "job": "Rasti mokėjimus, kurie nesutampa su draudiko ataskaita",
          "description": "Puslapyje „Mokėjimai“ slinkite lentelę iki draudiko ataskaitos stulpelių (ataskaitos numeris, data, „Draudiko ataskaitos įmokos suma“, komisinis ir komisinio tarifas). Raudona reikšmė reiškia, kad susietoje draudiko ataskaitoje nurodyta kita įmoka, komisinis ar tarifas nei PCT; raudonas „Declared premium“ reiškia, kad deklaruota suma skiriasi nuo užskaitytos įmokos. Datos tipo sąraše pasirinkite „Draudiko ataskaitos data“, kad matytumėte vieną ataskaitos laikotarpį, o „Export Excel“ pateiks tas pačias raudonas žymes faile.",
          "aliases": [
            "raudonos sumos",
            "nesutampa su draudiko ataskaita",
            "skiriasi komisinis",
            "sutikrinti su draudiko ataskaita",
            "kodel suma raudona"
          ]
        },
        "lv": {
          "job": "Atrast maksājumus, kas atšķiras no apdrošinātāja atskaites",
          "description": "Lapā \"Payments\" ritiniet tabulu līdz apdrošinātāja atskaites kolonnām (atskaites numurs, datums, \"Apdrošinātāja atskaites prēmijas summa\", komisija un komisijas likme). Sarkana vērtība nozīmē, ka saistītajā apdrošinātāja atskaitē norādīta cita prēmija, komisija vai likme nekā PCT; sarkans \"Declared premium\" nozīmē, ka deklarētā summa atšķiras no piesaistītās prēmijas. Datuma veida sarakstā izvēlieties \"Apdrošinātāja atskaites datums\", lai skatītu vienu atskaites periodu, un \"Export Excel\" dos tās pašas sarkanās atzīmes failā.",
          "aliases": [
            "sarkanas summas",
            "nesakrīt ar apdrošinātāja atskaiti",
            "atšķiras komisija",
            "salīdzināt ar atskaiti",
            "kapec summa sarkana"
          ]
        }
      }
    },
    {
      "id": "PPL-001",
      "area": "payment-plans",
      "job": "See a client's payment plan and what they still owe",
      "description": "On Payment plans, start typing the client's name or internal number in \"Select client\" on the second toolbar line and pick the client. The list then shows only that client's premium instalments with Total, Paid and Debt per instalment; widen the date range if older or later instalments are missing, because the page opens with roughly the last three months only. Picking a client here replaces any client filter set in Column options.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "client payment plan",
        "client instalments",
        "what does the client owe",
        "client debt",
        "outstanding premium for a client",
        "client premium schedule",
        "unpaid premiums of a client",
        "installment plan of client",
        "how much the client owes",
        "amount owed on client policies",
        "clients open policies"
      ],
      "anchor": "payment-plans-client",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Peržiūrėti kliento mokėjimų planą ir skolą",
          "description": "Puslapyje „Mokėjimų planas“ antroje įrankių juostos eilutėje lauke „Pasirinkti klientą“ pradėkite rašyti kliento pavadinimą ar vidinį numerį ir pasirinkite klientą. Sąraše liks tik šio kliento įmokos su „Bendra suma“, „Apmokėta“ ir „Skola“ kiekvienai įmokai; jei trūksta senesnių ar vėlesnių įmokų, praplėskite datų intervalą, nes puslapis atsidaro maždaug tik su paskutiniais trimis mėnesiais. Pasirinkus klientą čia, pakeičiamas kliento filtras iš „Stulpelių parinkčių“.",
          "aliases": [
            "kliento mokėjimų planas",
            "kliento skola",
            "kliento įmokos",
            "kliento imokos",
            "kiek skolingas klientas",
            "kliento mokejimu planas",
            "neapmokėtos kliento įmokos"
          ]
        },
        "lv": {
          "job": "Skatīt klienta maksājumu grafiku un parādu",
          "description": "Lapā “Payment plans” otrajā rīkjoslas rindā laukā “Select client” sāciet rakstīt klienta nosaukumu vai iekšējo numuru un izvēlieties klientu. Sarakstā paliks tikai šī klienta prēmiju maksājumi ar “Total”, “Paid” un “Debt” katram maksājumam; ja trūkst vecāku vai vēlāku maksājumu, paplašiniet datumu periodu, jo lapa atveras aptuveni tikai ar pēdējiem trim mēnešiem. Izvēloties klientu šeit, tiek aizstāts klienta filtrs no “Column options”.",
          "aliases": [
            "klienta maksājumu grafiks",
            "klienta parāds",
            "klienta prēmijas",
            "klienta maksajumu grafiks",
            "cik klients ir parādā",
            "klienta parads",
            "neapmaksātās klienta prēmijas"
          ]
        }
      }
    },
    {
      "id": "PPL-002",
      "area": "payment-plans",
      "job": "Find an instalment by policy number or licence plate",
      "description": "Type into the \"Search\" box at the top of Payment plans. It searches policy name, number and sub-number, client and payer names, company or personal codes, licence plate, VIN, reminder number and insurer report number, and the list filters half a second after you stop typing. In a word with characters such as \"-\" or \"/\", type each part between them in full: \"111-222\" finds 111-222, \"111-22\" does not. The search only looks inside the current date range and other filters, so widen the dates or clear the client and insurer pickers if nothing turns up.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "search policy number",
        "find policy",
        "search by licence plate",
        "search by car number",
        "find by VIN",
        "search payment plan",
        "look up instalment",
        "find premium by reminder number",
        "search insurer report number"
      ],
      "anchor": "payment-plans-search",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Rasti įmoką pagal poliso ar valstybinį numerį",
          "description": "Rašykite į laukelį „Search“ puslapio „Mokėjimų planas“ viršuje. Ieškoma pagal poliso pavadinimą, numerį ir subnumerį, kliento ir mokėtojo vardus, įmonės ar asmens kodus, valstybinį numerį, VIN, priminimo numerį ir draudiko ataskaitos numerį; sąrašas filtruojamas praėjus pusei sekundės po to, kai baigiate rašyti. Žodyje su tokiais simboliais kaip „-“ ar „/“ kiekvieną dalį tarp jų įveskite visą: „111-222“ randa 111-222, o „111-22“ – ne. Paieška vyksta tik esamame datų intervale ir su kitais filtrais, todėl jei nieko nerandate, praplėskite datas arba išvalykite kliento ir draudiko laukus.",
          "aliases": [
            "ieškoti poliso",
            "poliso numeris",
            "paieška pagal valstybinį numerį",
            "ieskoti poliso",
            "valstybinis numeris",
            "automobilio numeris",
            "rasti įmoką"
          ]
        },
        "lv": {
          "job": "Atrast maksājumu pēc polises vai transportlīdzekļa numura",
          "description": "Rakstiet laukā “Search” lapas “Payment plans” augšā. Meklēšana notiek pēc polises nosaukuma, numura un apakšnumura, klienta un maksātāja vārdiem, uzņēmuma vai personas kodiem, transportlīdzekļa numura, VIN, atgādinājuma numura un apdrošinātāja atskaites numura; saraksts tiek filtrēts pussekundi pēc tam, kad beidzat rakstīt. Vārdā ar tādām rakstzīmēm kā “-” vai “/” katru daļu starp tām ierakstiet pilnībā: “111-222” atrod 111-222, bet “111-22” – ne. Meklēšana notiek tikai pašreizējā datumu periodā un ar citiem filtriem, tāpēc, ja neko neatrodat, paplašiniet datumus vai notīriet klienta un apdrošinātāja laukus.",
          "aliases": [
            "meklēt polisi",
            "polises numurs",
            "meklēt pēc auto numura",
            "meklet polisi",
            "transportlīdzekļa numurs",
            "valsts numurs",
            "atrast maksājumu"
          ]
        }
      }
    },
    {
      "id": "PPL-003",
      "area": "payment-plans",
      "job": "List only unpaid premium instalments",
      "description": "Open \"Column options\" on the second toolbar line of Payment plans, click the funnel next to IP (is paid) in the selected columns on the right, choose No and press Apply. The list then holds only instalments that are not yet paid, and the Debt column shows what is still open on each; the button stays highlighted while the filter is active. Save the layout as a view in the same panel to reuse it, and note that an entry only becomes paid once money is cleared against it on Bank statements or Client balance.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "unpaid premiums",
        "open instalments",
        "outstanding premiums",
        "overdue premiums",
        "debtors list",
        "filter not paid",
        "show only debt",
        "who has not paid",
        "unpaid payment plans"
      ],
      "anchor": "payment-plans-column-options",
      "anchor_action": "open",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Rodyti tik neapmokėtas įmokas",
          "description": "Puslapio „Mokėjimų planas“ antroje įrankių juostos eilutėje atidarykite „Stulpelių parinktys“, dešinėje pasirinktų stulpelių sąraše spustelėkite piltuvėlį prie IP (apmokėta), pasirinkite „Ne“ ir paspauskite „Taikyti“. Sąraše liks tik dar neapmokėtos įmokos, o stulpelyje „Skola“ matysite, kiek liko sumokėti; kol filtras aktyvus, mygtukas paryškintas. Išdėstymą galite išsaugoti kaip vaizdą tame pačiame skydelyje; įrašas tampa apmokėtas tik tada, kai jam sudengiami pinigai puslapyje „Banko išrašai“ arba „Kliento balansas“.",
          "aliases": [
            "neapmokėtos įmokos",
            "neapmoketos imokos",
            "skolininkai",
            "pradelstos įmokos",
            "kas nesumokėjo",
            "tik skolos",
            "atviros įmokos"
          ]
        },
        "lv": {
          "job": "Rādīt tikai neapmaksātos prēmiju maksājumus",
          "description": "Lapas “Payment plans” otrajā rīkjoslas rindā atveriet “Column options”, labajā pusē atlasīto kolonnu sarakstā noklikšķiniet uz piltuves pie IP (is paid), izvēlieties “No” un nospiediet “Apply”. Sarakstā paliks tikai vēl neapmaksātie maksājumi, un kolonnā “Debt” redzams, cik vēl atlicis; kamēr filtrs ir aktīvs, poga ir izcelta. Izkārtojumu var saglabāt kā skatu tajā pašā panelī; ieraksts kļūst samaksāts tikai tad, kad tam piesaista naudu lapā “Bankas konta izraksti” vai “Client balance”.",
          "aliases": [
            "neapmaksātās prēmijas",
            "neapmaksatas premijas",
            "parādnieki",
            "kavētie maksājumi",
            "kas nav samaksājis",
            "tikai parādi",
            "atvērtie maksājumi"
          ]
        }
      }
    },
    {
      "id": "PPL-004",
      "area": "payment-plans",
      "job": "Show instalments due in a specific period",
      "description": "Set the two date fields on the first toolbar line of Payment plans (type D.M.YYYY or use the calendar) and choose in the list next to them whether they apply to the \"Booking date\" of the instalment, to the \"Insurer report date\" or to the \"Payment date\". The page opens with booking dates from 3 months minus 15 days ago up to 15 days ahead, so change the dates to see anything older or later. Entries not yet reported by an insurer have no insurer report date and drop out of that filter. \"Payment date\" keeps the entries whose last payment or last discount payment falls in the range, so unpaid entries drop out.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "filter by date",
        "date range",
        "instalments due this month",
        "change period",
        "booking date filter",
        "older payment plans missing",
        "insurer report date filter",
        "from date to date",
        "payment date filter",
        "paid in period",
        "entries paid this month"
      ],
      "anchor": "payment-plans-date-from",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Rodyti įmokas už konkretų laikotarpį",
          "description": "Puslapio „Mokėjimų planas“ pirmoje įrankių juostos eilutėje nustatykite abi datas (įveskite D.M.YYYY arba pasirinkite kalendoriuje) ir greta esančiame sąraše pasirinkite, ar jos taikomos „Įmokos data“, „Draudiko ataskaitos data“ ar „Mokėjimo data“. Puslapis atsidaro su įmokų datomis nuo 3 mėnesių be 15 dienų iki šiandienos iki 15 dienų į priekį, todėl norėdami matyti senesnes ar vėlesnes įmokas pakeiskite datas. Draudiko dar nepateikti įrašai neturi draudiko ataskaitos datos ir pagal šį filtrą nerodomi. „Mokėjimo data“ palieka įrašus, kurių paskutinis mokėjimas arba paskutinis nuolaidos mokėjimas patenka į intervalą, todėl neapmokėti įrašai nerodomi.",
          "aliases": [
            "filtruoti pagal datą",
            "datų intervalas",
            "laikotarpis",
            "filtruoti pagal data",
            "įmokos data",
            "imokos data",
            "trūksta senų įmokų",
            "mokėjimo data",
            "mokejimo data",
            "apmokėta per laikotarpį"
          ]
        },
        "lv": {
          "job": "Rādīt maksājumus noteiktā periodā",
          "description": "Lapas “Payment plans” pirmajā rīkjoslas rindā iestatiet abus datumus (ievadiet D.M.YYYY vai izmantojiet kalendāru) un blakus esošajā sarakstā izvēlieties, vai tie attiecas uz “Booking date”, “Apdrošinātāja atskaites datums” vai “Payment date”. Lapa atveras ar datumiem no 3 mēnešiem mīnus 15 dienām pirms šodienas līdz 15 dienām uz priekšu, tāpēc mainiet datumus, lai redzētu vecākus vai vēlākus maksājumus. Ierakstiem, par kuriem apdrošinātājs vēl nav ziņojis, nav atskaites datuma, un šajā filtrā tie netiek rādīti. “Payment date” patur ierakstus, kuru pēdējais maksājums vai pēdējais atlaides maksājums iekrīt periodā, tāpēc neapmaksātie ieraksti netiek rādīti.",
          "aliases": [
            "filtrēt pēc datuma",
            "datumu periods",
            "periods",
            "filtret pec datuma",
            "trūkst vecu maksājumu",
            "booking date",
            "nākamā mēneša maksājumi",
            "nakama menesa maksajumi",
            "šī mēneša maksājumi",
            "maksājumi par mēnesi",
            "payment date",
            "apmaksāts periodā",
            "samaksāts periodā"
          ]
        }
      }
    },
    {
      "id": "PPL-005",
      "area": "payment-plans",
      "job": "Show only broker premium collection policies",
      "description": "Use the premium collection list on the second toolbar line of Payment plans. \"Broker premium collection\" keeps only policies whose premium payment mean is premium collection by GrECo, \"Insurer premium collection\" keeps all other policies, where the client pays the insurer directly, and \"All types of premium collection\" shows both. The choice also applies to the Excel and PDF exports.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "broker collection",
        "premium collected by GrECo",
        "insurer collection",
        "direct payment to insurer",
        "premium payment mean filter",
        "collection type"
      ],
      "anchor": "payment-plans-collection-type",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Rodyti tik brokerio renkamų įmokų polisus",
          "description": "Naudokite įmokų surinkimo sąrašą puslapio „Mokėjimų planas“ antroje įrankių juostos eilutėje. „Broker premium collection“ palieka tik polisus, kurių įmokos tipas yra įmokų surinkimas per GrECo, „Insurer premium collection“ palieka visus kitus polisus, kai klientas moka tiesiogiai draudikui, o „Visi įmokų surinkimo būdai“ rodo abu. Pasirinkimas taikomas ir Excel bei PDF eksportui.",
          "aliases": [
            "brokerio įmokų surinkimas",
            "brokerio imoku surinkimas",
            "draudiko įmokų surinkimas",
            "įmokos tipas",
            "mokėjimas tiesiogiai draudikui"
          ]
        },
        "lv": {
          "job": "Rādīt tikai brokera iekasēto prēmiju polises",
          "description": "Izmantojiet prēmiju iekasēšanas sarakstu lapas “Payment plans” otrajā rīkjoslas rindā. “Broker premium collection” atstāj tikai polises, kuru prēmijas maksāšanas veids ir prēmiju iekasēšana caur GrECo, “Insurer premium collection” atstāj visas pārējās polises, kurās klients maksā tieši apdrošinātājam, bet “All types of premium collection” rāda abas. Izvēle attiecas arī uz Excel un PDF eksportu.",
          "aliases": [
            "brokera prēmiju iekasēšana",
            "brokera premiju iekasesana",
            "apdrošinātāja iekasēšana",
            "maksājums tieši apdrošinātājam",
            "prēmijas maksāšanas veids"
          ]
        }
      }
    },
    {
      "id": "PPL-006",
      "area": "payment-plans",
      "job": "Get the latest policies and premiums from GOS",
      "description": "Press \"GOS Sync\" at the right of the second toolbar line on Payment plans; hovering it shows when the last sync ran. It copies new and changed clients, policies and premium instalments from GOS in the background and takes a few minutes, so press the refresh button afterwards to see the result. If a sync was started within the last minute you get \"Sync GOS is already in progress\".",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Write access in PCT. Users with limited (read-only) access are refused.",
      "aliases": [
        "sync with GOS",
        "synchronise GOS",
        "new policy not showing",
        "refresh data from GOS",
        "update policies",
        "import policies from GOS",
        "premium missing in PCT",
        "last sync time"
      ],
      "anchor": "payment-plans-gos-sync",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Gauti naujausius polisus ir įmokas iš GOS",
          "description": "Puslapio „Mokėjimų planas“ antros įrankių juostos eilutės dešinėje paspauskite „GOS Sync“; užvedę pelę matysite, kada vyko paskutinis sinchronizavimas. Jis fone perkelia naujus ir pakeistus klientus, polisus ir įmokas iš GOS ir trunka kelias minutes, todėl po to paspauskite atnaujinimo mygtuką. Jei sinchronizavimas paleistas per paskutinę minutę, gausite pranešimą „Sync GOS is already in progress“.",
          "prerequisites": "Rašymo teisė PCT. Ribotos (tik skaitymo) prieigos naudotojams neleidžiama.",
          "aliases": [
            "sinchronizuoti su GOS",
            "GOS sinchronizavimas",
            "naujas polisas nerodomas",
            "atnaujinti duomenis iš GOS",
            "sinchronizacija",
            "trūksta įmokos"
          ]
        },
        "lv": {
          "job": "Ielādēt jaunākās polises un prēmijas no GOS",
          "description": "Lapas “Payment plans” otrās rīkjoslas rindas labajā pusē nospiediet “GOS Sync”; uzvirzot peli, redzams, kad notika pēdējā sinhronizācija. Tā fonā pārnes jaunus un mainītus klientus, polises un prēmiju maksājumus no GOS un ilgst dažas minūtes, tāpēc pēc tam nospiediet atjaunošanas pogu. Ja sinhronizācija palaista pēdējās minūtes laikā, saņemsiet ziņu “Sync GOS is already in progress”.",
          "prerequisites": "Rakstīšanas tiesības PCT. Lietotājiem ar ierobežotu (tikai lasīšanas) piekļuvi tas nav atļauts.",
          "aliases": [
            "sinhronizēt ar GOS",
            "GOS sinhronizācija",
            "jauna polise neparādās",
            "sinhronizet ar GOS",
            "atjaunot datus no GOS",
            "trūkst prēmijas"
          ]
        }
      }
    },
    {
      "id": "PPL-007",
      "area": "payment-plans",
      "job": "Export payment plans to Excel or PDF",
      "description": "Set the filters first, then press \"Export Excel\" or \"Export PDF\" on the first toolbar line of Payment plans. Both export every entry matching the current filters, not only the rows loaded on screen, with the visible columns in their current order; Excel downloads \"Payment Plans <date time>.xlsx\" and PDF opens in the browser. Large results take a while because all rows are loaded first, and insurer report values that differ from PCT are coloured red in the Excel file.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "export to excel",
        "download payment plans",
        "xlsx export",
        "print payment plans",
        "export pdf",
        "payment plan report",
        "save list as spreadsheet"
      ],
      "anchor": "payment-plans-export-excel",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Eksportuoti mokėjimų planą į Excel ar PDF",
          "description": "Pirmiausia nustatykite filtrus, tada puslapio „Mokėjimų planas“ pirmoje įrankių juostos eilutėje paspauskite „Export Excel“ arba „Eksportuoti PDF“. Abu eksportuoja visus esamus filtrus atitinkančius įrašus, ne tik ekrane įkeltas eilutes, su matomais stulpeliais esama tvarka; Excel atsisiunčia failą „Payment Plans <data laikas>.xlsx“, o PDF atsidaro naršyklėje. Dideli rezultatai užtrunka, nes pirmiausia įkeliamos visos eilutės, o draudiko ataskaitos reikšmės, kurios skiriasi nuo PCT, Excel faile nuspalvintos raudonai.",
          "aliases": [
            "eksportuoti į excel",
            "eksportuoti i excel",
            "atsisiųsti mokėjimų planą",
            "pdf eksportas",
            "spausdinti sąrašą",
            "ataskaita excel"
          ]
        },
        "lv": {
          "job": "Eksportēt maksājumu grafikus uz Excel vai PDF",
          "description": "Vispirms iestatiet filtrus, tad lapas “Payment plans” pirmajā rīkjoslas rindā nospiediet “Export Excel” vai “Export PDF”. Abi eksportē visus ierakstus, kas atbilst pašreizējiem filtriem, ne tikai ekrānā ielādētās rindas, ar redzamajām kolonnām pašreizējā secībā; Excel lejupielādē failu “Payment Plans <datums laiks>.xlsx”, bet PDF atveras pārlūkā. Lieli rezultāti aizņem laiku, jo vispirms tiek ielādētas visas rindas, un apdrošinātāja atskaites vērtības, kas atšķiras no PCT, Excel failā ir iekrāsotas sarkanā krāsā.",
          "aliases": [
            "eksportēt uz excel",
            "eksportet uz excel",
            "lejupielādēt maksājumu grafiku",
            "pdf eksports",
            "drukāt sarakstu",
            "atskaite excel"
          ]
        }
      }
    },
    {
      "id": "PPL-008",
      "area": "payment-plans",
      "job": "Check instalments against the insurer report",
      "description": "Add the insurer report columns (report number, date, premium, commission, commission rate) in Column options, for example with \"Add all\" on the \"Insurer report\" group; they are hidden by default. A red amount in those columns means the insurer report states a different premium, commission or rate than PCT holds for that instalment, and the Excel export colours the same cells. To list only entries from a given report period, switch the date-type list next to the dates to \"Insurer report date\".",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "red amounts",
        "why is the amount red",
        "insurer report mismatch",
        "compare with insurer report",
        "commission difference",
        "premium differs from insurer",
        "reconcile insurer report"
      ],
      "anchor": "payment-plans-grid",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Palyginti įmokas su draudiko ataskaita",
          "description": "„Stulpelių parinktyse“ įjunkite draudiko ataskaitos stulpelius (ataskaitos numeris, data, įmoka, komisiniai, komisinių tarifas), pvz., grupėje „Draudiko ataskaita“ spustelėję „Pridėti visus“; numatytai jie paslėpti. Raudona suma šiuose stulpeliuose reiškia, kad draudiko ataskaitoje nurodyta kita įmoka, komisiniai ar tarifas nei PCT turi šiai įmokai, o Excel eksporte tie patys langeliai taip pat nuspalvinti. Norėdami matyti tik tam tikro ataskaitų laikotarpio įrašus, datos tipo sąraše šalia datų pasirinkite „Draudiko ataskaitos data“.",
          "aliases": [
            "raudonos sumos",
            "kodėl suma raudona",
            "kodel suma raudona",
            "neatitikimas su draudiko ataskaita",
            "komisinių skirtumas",
            "palyginti su draudiko ataskaita"
          ]
        },
        "lv": {
          "job": "Salīdzināt maksājumus ar apdrošinātāja atskaiti",
          "description": "“Column options” pievienojiet apdrošinātāja atskaites kolonnas (atskaites numurs, datums, prēmija, komisija, komisijas likme), piemēram, grupā “Insurer report” ar “Add all”; pēc noklusējuma tās ir paslēptas. Sarkana summa šajās kolonnās nozīmē, ka apdrošinātāja atskaitē norādīta cita prēmija, komisija vai likme nekā PCT šim maksājumam, un Excel eksportā tās pašas šūnas arī ir iekrāsotas. Lai redzētu tikai noteikta atskaišu perioda ierakstus, datuma veida sarakstā blakus datumiem izvēlieties “Apdrošinātāja atskaites datums”.",
          "aliases": [
            "sarkanas summas",
            "kāpēc summa sarkana",
            "kapec summa sarkana",
            "neatbilstība apdrošinātāja atskaitei",
            "komisijas starpība",
            "salīdzināt ar apdrošinātāja atskaiti"
          ]
        }
      }
    },
    {
      "id": "PPL-009",
      "area": "payment-plans",
      "job": "See all instalments of one insurer",
      "description": "Start typing the insurer's name or number in \"Search insurers\" on the second toolbar line of Payment plans and pick it; insurers with a short name are listed first. The list then shows only that insurer's entries within the current date range, and picking one here replaces an insurer filter set in Column options. Combine it with \"Select client\" to see one client's policies with that insurer.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/paymentPlans",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "filter by insurer",
        "insurer instalments",
        "payment plans per insurer",
        "premiums for one insurance company",
        "insurance company filter",
        "show insurer policies"
      ],
      "anchor": "payment-plans-insurer",
      "source_ref": "help:PaymentPlan",
      "i18n": {
        "lt": {
          "job": "Matyti visas vieno draudiko įmokas",
          "description": "Puslapio „Mokėjimų planas“ antroje įrankių juostos eilutėje lauke „Pasirinkti draudiką“ pradėkite rašyti draudiko pavadinimą ar numerį ir pasirinkite jį; draudikai su trumpuoju pavadinimu rodomi pirmi. Sąraše liks tik šio draudiko įrašai esamame datų intervale, o pasirinkimas čia pakeičia draudiko filtrą iš „Stulpelių parinkčių“. Derinkite su „Pasirinkti klientą“, kad matytumėte vieno kliento polisus pas šį draudiką.",
          "aliases": [
            "filtruoti pagal draudiką",
            "filtruoti pagal draudika",
            "draudiko įmokos",
            "draudiko imokos",
            "draudimo bendrovė",
            "vieno draudiko mokėjimų planas"
          ]
        },
        "lv": {
          "job": "Redzēt visus viena apdrošinātāja maksājumus",
          "description": "Lapas “Payment plans” otrajā rīkjoslas rindā laukā “Search insurers” sāciet rakstīt apdrošinātāja nosaukumu vai numuru un izvēlieties to; apdrošinātāji ar īso nosaukumu tiek rādīti pirmie. Sarakstā paliks tikai šī apdrošinātāja ieraksti pašreizējā datumu periodā, un izvēle šeit aizstāj apdrošinātāja filtru no “Column options”. Apvienojiet ar “Select client”, lai redzētu viena klienta polises pie šī apdrošinātāja.",
          "aliases": [
            "filtrēt pēc apdrošinātāja",
            "filtret pec apdrosinataja",
            "apdrošinātāja maksājumi",
            "apdrošināšanas sabiedrība",
            "viena apdrošinātāja maksājumu grafiks"
          ]
        }
      }
    },
    {
      "id": "REM-001",
      "area": "reminders",
      "job": "Create a payment reminder for a client",
      "description": "On Reminders pick the client in the \"Client\" field, then click \"Create reminder\" next to it (with several GrECo companies ticked, choose the company first). In the dialog set the booking-date range, insurer, currency and \"Broker premium collection\", click \"Search\" and untick the instalments you do not want (a light-red row belongs to a cancelled policy); each \"Reminder value\" starts as the outstanding debt. Check the reminder number (or clear it to have one generated as \"P\", the date and the reminder id; for GrECo Latvia it is left empty), payer and comment, then click \"Create reminder\": the PDF documents are generated and the reminder appears in the list.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client must be selected first (for one reminder covering several clients of a payer, select the payer instead). Users with the limited PCT role cannot create reminders.",
      "aliases": [
        "new reminder",
        "create reminder",
        "dunning letter",
        "payment reminder",
        "remind client to pay",
        "overdue premium notice",
        "generate reminder",
        "make an invoice for unpaid premium",
        "prepare a dunning notice"
      ],
      "anchor": "reminders-create-button",
      "anchor_action": "open",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Sukurti mokėjimo priminimą klientui",
          "description": "Puslapyje \"Priminimai\" lauke \"Klientas\" pasirinkite klientą ir spauskite šalia esantį \"Create reminder\" (jei pažymėtos kelios GrECo įmonės, pirmiausia pasirinkite įmonę). Lange nustatykite įmokų datų intervalą, draudiką, valiutą ir \"Broker premium collection\", spauskite \"Ieškoti\" ir atžymėkite nereikalingas įmokas (šviesiai raudona eilutė priklauso nutrauktam polisui); kiekvienos \"Reminder value\" iš pradžių lygi likusiai skolai. Patikrinkite priminimo numerį (arba ištrinkite jį, kad būtų sugeneruotas iš „P“, datos ir priminimo id; GrECo Latvia atveju jis paliekamas tuščias), mokėtoją ir komentarą, tada spauskite \"Create reminder\": sugeneruojami PDF dokumentai, o priminimas atsiranda sąraše.",
          "prerequisites": "Pirmiausia reikia pasirinkti klientą (vienam priminimui keliems mokėtojo klientams pasirinkite mokėtoją). Ribotos PCT rolės naudotojai priminimų kurti negali.",
          "aliases": [
            "naujas priminimas",
            "sukurti priminima",
            "priminimas apie mokėjimą",
            "priminti klientui sumokėti",
            "pradelstos įmokos",
            "saskaita uz nesumoketa imoka",
            "raginimas mokėti"
          ]
        },
        "lv": {
          "job": "Izveidot maksājuma atgādinājumu klientam",
          "description": "Lapā \"Reminders\" laukā \"Client\" izvēlieties klientu un noklikšķiniet blakus esošo \"Create reminder\" (ja atzīmēti vairāki GrECo uzņēmumi, vispirms izvēlieties uzņēmumu). Logā iestatiet iemaksu datumu intervālu, apdrošinātāju, valūtu un \"Broker premium collection\", noklikšķiniet \"Search\" un noņemiet atzīmi nevajadzīgajām iemaksām (gaiši sarkana rinda pieder anulētai polisei); katra \"Reminder value\" sākumā ir atlikušais parāds. Pārbaudiet atgādinājuma numuru (vai dzēsiet to, lai tas tiktu ģenerēts no „P“, datuma un atgādinājuma id; GrECo Latvia gadījumā tas paliek tukšs), maksātāju un komentāru, tad noklikšķiniet \"Create reminder\": tiek ģenerēti PDF dokumenti, un atgādinājums parādās sarakstā.",
          "prerequisites": "Vispirms jāizvēlas klients (vienam atgādinājumam vairākiem maksātāja klientiem izvēlieties maksātāju). Lietotāji ar ierobežoto PCT lomu nevar izveidot atgādinājumus.",
          "aliases": [
            "jauns atgādinājums",
            "izveidot atgadinajumu",
            "maksājuma atgādinājums",
            "atgādināt klientam samaksāt",
            "kavētas iemaksas",
            "rēķins par neapmaksātu prēmiju",
            "brīdinājums par parādu"
          ]
        }
      }
    },
    {
      "id": "REM-002",
      "area": "reminders",
      "job": "Email a reminder to the client",
      "description": "In the reminders list click the envelope icon (\"Send by email\") in the reminder's row; it is shown only when the reminder has a generated document. The recipient is filled from the premium collection email of the client's valid mandate (type it yourself if a warning says none is set), and the subject, text and preferred PDF come from the company template. Check the attachments and text, then click \"Send\": the mail goes out from your own mailbox and the reminder is marked as sent with the date and recipients.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "The reminder must have a generated document. Users with the limited PCT role can send reminders too (they cannot create or delete them).",
      "aliases": [
        "send reminder",
        "email reminder",
        "mail the invoice to client",
        "send dunning letter by email",
        "send reminder pdf",
        "resend reminder",
        "forward reminder to client",
        "send payment reminder to client",
        "email payment reminder",
        "reminder sent date",
        "was the reminder sent",
        "reminders sent by email"
      ],
      "anchor": "reminders-row-send-email",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Išsiųsti priminimą klientui el. paštu",
          "description": "Priminimų sąraše spauskite voko piktogramą (\"Send by email\") priminimo eilutėje; ji rodoma tik tada, kai priminimas turi sugeneruotą dokumentą. Gavėjas užpildomas įmokų surinkimo el. paštu iš galiojančio kliento mandato (jei įspėjimas rodo, kad jo nėra, įveskite patys), o tema, tekstas ir pageidaujamas PDF paimami iš įmonės šablono. Patikrinkite priedus ir tekstą, tada spauskite \"Send\": laiškas išsiunčiamas iš jūsų pašto dėžutės, o priminimas pažymimas kaip išsiųstas su data ir gavėjais.",
          "prerequisites": "Priminimas turi turėti sugeneruotą dokumentą. Ribotos PCT rolės naudotojai priminimus siųsti gali (bet negali jų kurti ar trinti).",
          "aliases": [
            "siųsti priminimą",
            "issiusti priminima el pastu",
            "priminimas el. paštu",
            "siųsti sąskaitą klientui",
            "pakartotinai išsiųsti priminimą"
          ]
        },
        "lv": {
          "job": "Nosūtīt atgādinājumu klientam pa e-pastu",
          "description": "Atgādinājumu sarakstā noklikšķiniet uz aploksnes ikonas (\"Send by email\") atgādinājuma rindā; tā redzama tikai tad, ja atgādinājumam ir ģenerēts dokuments. Saņēmējs tiek aizpildīts ar prēmiju iekasēšanas e-pastu no klienta derīgā mandāta (ja brīdinājums rāda, ka tā nav, ierakstiet pats), bet temats, teksts un vēlamais PDF tiek ņemti no uzņēmuma veidnes. Pārbaudiet pielikumus un tekstu, tad noklikšķiniet \"Send\": vēstule tiek nosūtīta no jūsu pastkastes, un atgādinājums tiek atzīmēts kā nosūtīts ar datumu un saņēmējiem.",
          "prerequisites": "Atgādinājumam jābūt ģenerētam dokumentam. Lietotāji ar ierobežoto PCT lomu arī var sūtīt atgādinājumus (bet nevar tos izveidot vai dzēst).",
          "aliases": [
            "nosūtīt atgādinājumu",
            "nosutit atgadinajumu pa epastu",
            "atgādinājums pa e-pastu",
            "nosūtīt rēķinu klientam",
            "atkārtoti nosūtīt atgādinājumu"
          ]
        }
      }
    },
    {
      "id": "REM-003",
      "area": "reminders",
      "job": "Download the reminder PDF",
      "description": "Each reminder row has download icons in its options column. The first (\"Download document\") opens the main PDF, which includes discounts; the second (\"Download additional document\"), when present, opens the version without discounts. The documents are generated once when the reminder is created, and outside production they carry a \"THIS IS A TEST DOCUMENT\" watermark.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "download reminder",
        "open reminder pdf",
        "print reminder",
        "reminder document",
        "get the invoice pdf",
        "reminder without discount",
        "proposal document"
      ],
      "anchor": "reminders-row-download",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Atsisiųsti priminimo PDF",
          "description": "Kiekvienos priminimo eilutės parinkčių stulpelyje yra atsisiuntimo piktogramos. Pirmoji (\"Atsisiųsti dokumentą\") atveria pagrindinį PDF su nuolaidomis; antroji, jei yra, atveria versiją be nuolaidų. Dokumentai sugeneruojami vieną kartą kuriant priminimą, o ne gamybinėje aplinkoje juose yra vandenženklis \"THIS IS A TEST DOCUMENT\".",
          "aliases": [
            "atsisiųsti priminimą",
            "atidaryti priminimo pdf",
            "spausdinti priminima",
            "priminimo dokumentas",
            "pasiūlymas pdf",
            "priminimas be nuolaidos"
          ]
        },
        "lv": {
          "job": "Lejupielādēt atgādinājuma PDF",
          "description": "Katras atgādinājuma rindas opciju kolonnā ir lejupielādes ikonas. Pirmā (\"Download document\") atver galveno PDF ar atlaidēm; otrā (\"Download additional document\"), ja tāda ir, atver versiju bez atlaidēm. Dokumenti tiek ģenerēti vienreiz, veidojot atgādinājumu, un ārpus ražošanas vides tiem ir ūdenszīme \"THIS IS A TEST DOCUMENT\".",
          "aliases": [
            "lejupielādēt atgādinājumu",
            "atvērt atgadinajuma pdf",
            "drukāt atgādinājumu",
            "atgādinājuma dokuments",
            "rēķins pdf",
            "atgādinājums bez atlaides"
          ]
        }
      }
    },
    {
      "id": "REM-004",
      "area": "reminders",
      "job": "Delete a wrong reminder",
      "description": "Click the delete icon (\"Delete reminder\") in the reminder's row, optionally write why in \"Comment\", and click \"Delete\". The reminder and all its instalment entries are marked as deleted and disappear from the list. A created reminder cannot be edited, so to correct one delete it and create it again; if a colleague changed it in the meantime the deletion is refused, so reload and retry.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "Users with the limited PCT role cannot delete reminders.",
      "aliases": [
        "delete reminder",
        "remove reminder",
        "cancel reminder",
        "wrong reminder",
        "reminder created by mistake",
        "correct a reminder",
        "edit reminder"
      ],
      "anchor": "reminders-row-delete",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Ištrinti klaidingą priminimą",
          "description": "Priminimo eilutėje spauskite trynimo piktogramą (\"Delete reminder\"), jei norite, lauke \"Komentaras\" įrašykite priežastį ir spauskite \"Ištrinti\". Priminimas ir visos jo įmokų eilutės pažymimos kaip ištrintos ir dingsta iš sąrašo. Sukurto priminimo redaguoti negalima, todėl norėdami pataisyti jį ištrinkite ir sukurkite iš naujo; jei kolega tuo metu jį pakeitė, trynimas atmetamas, tad atnaujinkite sąrašą ir bandykite dar kartą.",
          "prerequisites": "Ribotos PCT rolės naudotojai priminimų trinti negali.",
          "aliases": [
            "ištrinti priminimą",
            "istrinti priminima",
            "atšaukti priminimą",
            "klaidingas priminimas",
            "pataisyti priminimą",
            "redaguoti priminima"
          ]
        },
        "lv": {
          "job": "Dzēst kļūdainu atgādinājumu",
          "description": "Atgādinājuma rindā noklikšķiniet uz dzēšanas ikonas (\"Delete reminder\"), ja vēlaties, laukā \"Comment\" ierakstiet iemeslu un noklikšķiniet \"Delete\". Atgādinājums un visas tā iemaksu rindas tiek atzīmētas kā dzēstas un pazūd no saraksta. Izveidotu atgādinājumu rediģēt nevar, tāpēc, lai to labotu, dzēsiet un izveidojiet no jauna; ja kolēģis to pa to laiku ir mainījis, dzēšana tiek atteikta, tāpēc pārlādējiet sarakstu un mēģiniet vēlreiz.",
          "prerequisites": "Lietotāji ar ierobežoto PCT lomu nevar dzēst atgādinājumus.",
          "aliases": [
            "dzēst atgādinājumu",
            "dzest atgadinajumu",
            "atcelt atgādinājumu",
            "kļūdains atgādinājums",
            "labot atgādinājumu",
            "rediģēt atgādinājumu"
          ]
        }
      }
    },
    {
      "id": "REM-005",
      "area": "reminders",
      "job": "Find an existing reminder",
      "description": "Type in the search box at the top of Reminders: it filters by reminder number, client name, insurer, comment or a date written as DD.MM.YYYY. It only searches reminders created inside the date range next to it, which by default covers about the last two months, so move the start date back for older ones. To narrow further pick the client in \"Client\" or the payer in \"Payer\" (one at a time), or enter an exact policy number or sub-number in the fields on the second row.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "search reminder",
        "find reminder by number",
        "look up reminder",
        "reminders of a client",
        "reminders for a policy",
        "old reminders",
        "reminder history"
      ],
      "anchor": "reminders-search",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Rasti esamą priminimą",
          "description": "Rašykite paieškos laukelyje puslapio \"Priminimai\" viršuje: filtruojama pagal priminimo numerį, kliento pavadinimą, draudiką, komentarą arba datą formatu DD.MM.YYYY. Ieškoma tik tarp priminimų, sukurtų šalia nurodytame datų intervale, kuris pagal nutylėjimą apima maždaug paskutinius du mėnesius, tad senesniems priminimams perkelkite pradžios datą atgal. Norėdami susiaurinti, pasirinkite klientą lauke \"Klientas\" arba mokėtoją lauke \"Mokėtojas\" (tik vieną), arba antroje eilutėje įveskite tikslų poliso numerį ar sub numerį.",
          "aliases": [
            "ieškoti priminimo",
            "rasti priminima pagal numeri",
            "kliento priminimai",
            "poliso priminimai",
            "seni priminimai",
            "priminimų istorija"
          ]
        },
        "lv": {
          "job": "Atrast esošu atgādinājumu",
          "description": "Rakstiet meklēšanas laukā lapas \"Reminders\" augšā: tiek filtrēts pēc atgādinājuma numura, klienta nosaukuma, apdrošinātāja, komentāra vai datuma formātā DD.MM.YYYY. Meklē tikai starp atgādinājumiem, kas izveidoti blakus norādītajā datumu intervālā, kas pēc noklusējuma aptver aptuveni pēdējos divus mēnešus, tāpēc vecākiem atgādinājumiem pārvietojiet sākuma datumu atpakaļ. Lai sašaurinātu, izvēlieties klientu laukā \"Client\" vai maksātāju laukā \"Payer\" (tikai vienu), vai otrajā rindā ievadiet precīzu polises numuru vai apakšnumuru.",
          "aliases": [
            "meklēt atgādinājumu",
            "atrast atgadinajumu pec numura",
            "klienta atgādinājumi",
            "polises atgādinājumi",
            "veci atgādinājumi",
            "atgādinājumu vēsture"
          ]
        }
      }
    },
    {
      "id": "REM-006",
      "area": "reminders",
      "job": "Check whether a reminder has been paid",
      "description": "In the reminders list the \"Status\" column shows two icons: the upper one for premium, the lower one for the discount. A green tick means paid, a half circle partially paid, an empty circle not paid, and a question mark means the premium is not collected by the broker; hover an icon for its meaning. The \"paid / amount\" columns show the exact figures. Money is matched to instalments on the Bank statements page, so click the refresh button to see payments cleared since the list was loaded.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "is reminder paid",
        "reminder status",
        "paid amount of reminder",
        "unpaid reminders",
        "open reminders",
        "did the client pay the reminder",
        "reminder payment status"
      ],
      "anchor": "reminders-grid",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Patikrinti, ar priminimas apmokėtas",
          "description": "Priminimų sąraše stulpelyje \"Statusas\" yra dvi piktogramos: viršutinė — įmokai, apatinė — nuolaidai. Žalia varnelė reiškia sumokėta, pusė apskritimo — sumokėta iš dalies, tuščias apskritimas — nesumokėta, o klaustukas — įmokos nerenka brokeris; užveskite pelę, kad matytumėte paaiškinimą. Tikslios sumos matomos \"apmokėta / suma\" stulpeliuose. Pinigai su įmokomis sudengiami puslapyje \"Banko išrašai\", tad spauskite atnaujinimo mygtuką, kad matytumėte vėliau sudengtus mokėjimus.",
          "aliases": [
            "ar priminimas apmoketas",
            "priminimo statusas",
            "apmokėta priminimo suma",
            "neapmokėti priminimai",
            "ar klientas sumokėjo"
          ]
        },
        "lv": {
          "job": "Pārbaudīt, vai atgādinājums ir apmaksāts",
          "description": "Atgādinājumu sarakstā kolonnā \"Status\" ir divas ikonas: augšējā prēmijai, apakšējā atlaidei. Zaļa ķeksīte nozīmē apmaksāts, pusaplis — daļēji apmaksāts, tukšs aplis — nav apmaksāts, bet jautājuma zīme — prēmiju neiekasē brokeris; novietojiet peli uz ikonas, lai redzētu skaidrojumu. Precīzas summas redzamas \"paid / amount\" kolonnās. Nauda ar iemaksām tiek sasaistīta lapā \"Bank statements\", tāpēc noklikšķiniet pārlādes pogu, lai redzētu vēlāk sasaistītos maksājumus.",
          "aliases": [
            "vai atgadinajums apmaksats",
            "atgādinājuma statuss",
            "apmaksātā summa",
            "neapmaksāti atgādinājumi",
            "vai klients samaksāja"
          ]
        }
      }
    },
    {
      "id": "REM-007",
      "area": "reminders",
      "job": "See which instalments a reminder contains",
      "description": "Tick the round checkbox at the start of the reminder's row: its instalments load into the lower list with policy, insurer, policy number and sub-number, insurance line, booking date, premium period and the paid / amount figures per instalment. Only one reminder can be selected at a time. The selected row also gets an \"Export Excel\" icon that downloads these instalments as an .xlsx file.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "aliases": [
        "reminder entries",
        "reminder details",
        "policies in reminder",
        "instalments of reminder",
        "export reminder to excel",
        "reminder lines",
        "what is included in the reminder"
      ],
      "anchor": "reminders-row-select",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Pamatyti, kokios įmokos yra priminime",
          "description": "Pažymėkite apvalų žymimąjį langelį priminimo eilutės pradžioje: jo įmokos įkeliamos į apatinį sąrašą su polisu, draudiku, poliso numeriu ir sub numeriu, draudimo rūšimi, įmokos data, įmokos laikotarpiu ir kiekvienos įmokos \"apmokėta / suma\" duomenimis. Vienu metu galima pasirinkti tik vieną priminimą. Pažymėtoje eilutėje taip pat atsiranda piktograma \"Export Excel\", kuri atsisiunčia šias įmokas .xlsx failu.",
          "aliases": [
            "priminimo eilutės",
            "priminimo detalės",
            "priminimo įmokos",
            "polisai priminime",
            "eksportuoti priminima i excel"
          ]
        },
        "lv": {
          "job": "Redzēt, kuras iemaksas ir atgādinājumā",
          "description": "Atzīmējiet apaļo izvēles rūtiņu atgādinājuma rindas sākumā: tā iemaksas tiek ielādētas apakšējā sarakstā ar polisi, apdrošinātāju, polises numuru un apakšnumuru, apdrošināšanas veidu, iemaksas datumu, prēmijas periodu un katras iemaksas \"paid / amount\" datiem. Vienlaikus var izvēlēties tikai vienu atgādinājumu. Atzīmētajā rindā parādās arī ikona \"Export Excel\", kas lejupielādē šīs iemaksas kā .xlsx failu.",
          "aliases": [
            "atgādinājuma rindas",
            "atgādinājuma detaļas",
            "atgādinājuma iemaksas",
            "polises atgādinājumā",
            "eksportēt atgadinajumu uz excel"
          ]
        }
      }
    },
    {
      "id": "REM-008",
      "area": "reminders",
      "job": "Set the payment due date on a reminder",
      "description": "The due date is taken from the \"Comment\" field of the \"Create reminder\" dialog. After \"Search\" it is pre-filled with the earliest booking date of the selected instalments and changes when you change the selection, so overwrite it last, just before clicking \"Create reminder\". GrECo Latvia documents print it as the invoice due date, and the reminder email uses it as the payment due date. Once the reminder exists it cannot be changed; delete the reminder and create it again.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client (or, for a reminder by payer, a payer) must be selected to open the Create reminder dialog.",
      "aliases": [
        "due date on reminder",
        "change payment deadline",
        "pay until date",
        "invoice due date",
        "wrong due date in reminder",
        "reminder comment",
        "payment term on reminder"
      ],
      "anchor": "reminders-create-comment",
      "anchor_surface": "reminders-create-button",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Nustatyti mokėjimo terminą priminime",
          "description": "Mokėjimo terminas imamas iš lango \"Create reminder\" lauko \"Komentaras\". Po \"Ieškoti\" jis užpildomas anksčiausia pažymėtų įmokų data ir keičiasi pakeitus pasirinkimą, todėl jį perrašykite paskiausiai, prieš pat spausdami \"Create reminder\". GrECo Latvia dokumentuose jis spausdinamas kaip sąskaitos apmokėjimo terminas, o priminimo el. laiške naudojamas kaip mokėjimo terminas. Sukūrus priminimą jo pakeisti nebegalima; ištrinkite priminimą ir sukurkite iš naujo.",
          "prerequisites": "Norint atverti langą Create reminder, reikia pasirinkti klientą (arba, mokėtojo priminimui, mokėtoją).",
          "aliases": [
            "mokėjimo terminas priminime",
            "pakeisti apmokejimo termina",
            "sumokėti iki",
            "sąskaitos terminas",
            "neteisingas terminas priminime",
            "priminimo komentaras"
          ]
        },
        "lv": {
          "job": "Iestatīt apmaksas termiņu atgādinājumā",
          "description": "Apmaksas termiņš tiek ņemts no loga \"Create reminder\" lauka \"Comment\". Pēc \"Search\" tas tiek aizpildīts ar agrāko atzīmēto iemaksu datumu un mainās, mainot izvēli, tāpēc pārrakstiet to pēdējo, tieši pirms noklikšķināt \"Create reminder\". GrECo Latvia dokumentos tas tiek drukāts kā rēķina apmaksas termiņš, bet atgādinājuma e-pastā — kā maksājuma termiņš. Kad atgādinājums ir izveidots, to mainīt vairs nevar; dzēsiet atgādinājumu un izveidojiet no jauna.",
          "prerequisites": "Lai atvērtu logu Create reminder, jāizvēlas klients (vai, maksātāja atgādinājumam, maksātājs).",
          "aliases": [
            "apmaksas termiņš atgādinājumā",
            "mainīt apmaksas terminu",
            "samaksāt līdz",
            "rēķina termiņš",
            "nepareizs termiņš atgādinājumā",
            "atgādinājuma komentārs"
          ]
        }
      }
    },
    {
      "id": "REM-009",
      "area": "reminders",
      "job": "Send a second reminder for the same instalments",
      "description": "By default the \"Create reminder\" dialog leaves out instalments that already belong to a reminder, so a follow-up finds nothing. Set \"Include installments already in reminder\" to \"Yes\" before clicking \"Search\", and give the new reminder its own number or clear the field so a unique one is generated — a number already used by another reminder is rejected.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client (or, for a reminder by payer, a payer) must be selected to open the Create reminder dialog.",
      "aliases": [
        "second reminder",
        "follow-up reminder",
        "remind again",
        "repeat reminder",
        "search finds no instalments",
        "instalments missing in reminder dialog",
        "already reminded instalments"
      ],
      "anchor": "reminders-create-include-existing",
      "anchor_surface": "reminders-create-button",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Siųsti pakartotinį priminimą dėl tų pačių įmokų",
          "description": "Pagal nutylėjimą lange \"Create reminder\" neįtraukiamos įmokos, kurios jau yra kitame priminime, todėl pakartotinio priminimo paieška nieko neranda. Prieš spausdami \"Ieškoti\" nustatykite \"Include installments already in reminder\" į \"Yes\" ir suteikite naujam priminimui savo numerį arba ištrinkite jį, kad būtų sugeneruotas unikalus — jau kito priminimo naudojamas numeris atmetamas.",
          "prerequisites": "Norint atverti langą Create reminder, reikia pasirinkti klientą (arba, mokėtojo priminimui, mokėtoją).",
          "aliases": [
            "antras priminimas",
            "pakartotinis priminimas",
            "priminti dar karta",
            "paieška neranda įmokų",
            "jau priminta įmoka"
          ]
        },
        "lv": {
          "job": "Nosūtīt atkārtotu atgādinājumu par tām pašām iemaksām",
          "description": "Pēc noklusējuma logā \"Create reminder\" netiek iekļautas iemaksas, kas jau ir citā atgādinājumā, tāpēc atkārtota atgādinājuma meklēšana neko neatrod. Pirms noklikšķināt \"Search\", iestatiet \"Include installments already in reminder\" uz \"Yes\" un piešķiriet jaunajam atgādinājumam savu numuru vai dzēsiet to, lai tiktu ģenerēts unikāls — cita atgādinājuma jau izmantots numurs tiek noraidīts.",
          "prerequisites": "Lai atvērtu logu Create reminder, jāizvēlas klients (vai, maksātāja atgādinājumam, maksātājs).",
          "aliases": [
            "otrs atgādinājums",
            "atkārtots atgādinājums",
            "atgādināt vēlreiz",
            "meklēšana neatrod iemaksas",
            "jau atgadinata iemaksa"
          ]
        }
      }
    },
    {
      "id": "REM-010",
      "area": "reminders",
      "job": "Remind premium that is paid directly to the insurer",
      "description": "In the \"Create reminder\" dialog set \"Broker premium collection\" to \"No\": only instalments paid directly to the insurer are then suggested. In that case you must pick exactly one insurer (choose the insurer country first, then the insurer) before \"Search\" becomes active; the server rejects a reminder that covers several insurers unless the premium is collected by the broker.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client (or, for a reminder by payer, a payer) must be selected to open the Create reminder dialog.",
      "aliases": [
        "insurer collects premium",
        "direct payment to insurer",
        "not broker premium collection",
        "bpc no",
        "search button disabled",
        "please select an insurer",
        "reminder for one insurer"
      ],
      "anchor": "reminders-create-broker",
      "anchor_surface": "reminders-create-button",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Priminti apie įmoką, mokamą tiesiai draudikui",
          "description": "Lange \"Create reminder\" nustatykite \"Broker premium collection\" į \"No\": tada siūlomos tik tiesiai draudikui mokamos įmokos. Šiuo atveju prieš tampant aktyviam mygtukui \"Ieškoti\" reikia pasirinkti lygiai vieną draudiką (pirmiausia draudiko šalį, tada draudiką); serveris atmeta priminimą keliems draudikams, jei įmokų nerenka brokeris.",
          "prerequisites": "Norint atverti langą Create reminder, reikia pasirinkti klientą (arba, mokėtojo priminimui, mokėtoją).",
          "aliases": [
            "draudikas renka įmokas",
            "mokėjimas tiesiai draudikui",
            "ne brokerio surinkimas",
            "ieškoti mygtukas neaktyvus",
            "pasirinkite draudika"
          ]
        },
        "lv": {
          "job": "Atgādināt par prēmiju, ko maksā tieši apdrošinātājam",
          "description": "Logā \"Create reminder\" iestatiet \"Broker premium collection\" uz \"No\": tad tiek piedāvātas tikai tieši apdrošinātājam maksājamās iemaksas. Šajā gadījumā, lai poga \"Search\" kļūtu aktīva, jāizvēlas tieši viens apdrošinātājs (vispirms apdrošinātāja valsts, tad apdrošinātājs); serveris noraida atgādinājumu vairākiem apdrošinātājiem, ja prēmiju neiekasē brokeris.",
          "prerequisites": "Lai atvērtu logu Create reminder, jāizvēlas klients (vai, maksātāja atgādinājumam, maksātājs).",
          "aliases": [
            "apdrošinātājs iekasē prēmiju",
            "maksājums tieši apdrošinātājam",
            "nav brokera iekasēšana",
            "search poga neaktīva",
            "izvelieties apdrosinataju"
          ]
        }
      }
    },
    {
      "id": "REM-011",
      "area": "reminders",
      "job": "Address a reminder to a different payer",
      "description": "In the \"Create reminder\" dialog the \"Payer\" field above the instalment list starts as the selected client. Search and pick another partner when someone else pays on the client's behalf; the reminder documents are then addressed to that payer. \"Create reminder\" stays disabled while the payer is empty. For a private person without a partner record tick \"Enter payer name manually\" and type the name instead. To suggest only instalments paid by certain payers, use \"Search payers\" in the left panel instead.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client must be selected to open the Create reminder dialog. For a reminder created by payer the field is fixed to the payer selected on the page.",
      "aliases": [
        "change payer",
        "reminder to employer",
        "another company pays",
        "payer of the reminder",
        "send reminder to payer",
        "recipient of reminder document"
      ],
      "anchor": "reminders-create-payer",
      "anchor_surface": "reminders-create-button",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Adresuoti priminimą kitam mokėtojui",
          "description": "Lange \"Create reminder\" laukas \"Mokėtojas\" virš įmokų sąrašo iš pradžių yra pasirinktas klientas. Suraskite ir pasirinkite kitą partnerį, jei už klientą moka kas nors kitas; tada priminimo dokumentai adresuojami tam mokėtojui. \"Create reminder\" neaktyvus, kol mokėtojas tuščias. Fiziniam asmeniui be partnerio įrašo pažymėkite \"Įvesti mokėtojo vardą rankiniu būdu\" ir įrašykite vardą. Jei norite siūlyti tik tam tikrų mokėtojų įmokas, naudokite \"Search payers\" kairiajame skydelyje.",
          "prerequisites": "Norint atverti langą Create reminder, reikia pasirinkti klientą. Mokėtojui kuriamame priminime laukas užfiksuotas puslapyje pasirinktam mokėtojui.",
          "aliases": [
            "pakeisti mokėtoją",
            "kitas mokėtojas",
            "priminimas darbdaviui",
            "priminimo gavejas",
            "moka kita įmonė"
          ]
        },
        "lv": {
          "job": "Adresēt atgādinājumu citam maksātājam",
          "description": "Logā \"Create reminder\" lauks \"Payer\" virs iemaksu saraksta sākumā ir izvēlētais klients. Atrodiet un izvēlieties citu partneri, ja klienta vietā maksā kāds cits; tad atgādinājuma dokumenti tiek adresēti šim maksātājam. \"Create reminder\" nav aktīva, kamēr maksātājs ir tukšs. Privātpersonai bez partnera ieraksta atzīmējiet \"Ievadīt maksātāja vārdu manuāli\" un ierakstiet vārdu. Lai piedāvātu tikai noteiktu maksātāju iemaksas, izmantojiet \"Search payers\" kreisajā panelī.",
          "prerequisites": "Lai atvērtu logu Create reminder, jāizvēlas klients. Maksātājam veidotā atgādinājumā lauks ir piesaistīts lapā izvēlētajam maksātājam.",
          "aliases": [
            "mainīt maksātāju",
            "cits maksātājs",
            "atgādinājums darba devējam",
            "atgadinajuma sanemejs",
            "maksā cits uzņēmums"
          ]
        }
      }
    },
    {
      "id": "REM-012",
      "area": "reminders",
      "job": "Create one reminder for a payer of several clients",
      "description": "On Reminders pick the payer in the \"Payer\" field (this clears the \"Client\" field), then click \"Create reminder\" next to it. In the dialog the \"Payer\" field is fixed to that payer, and the left panel offers \"Select clients\" instead of payers: pick at least one client. Click \"Search\" to get the unpaid instalments of the selected clients, untick unwanted ones and click \"Create reminder\": one reminder, addressed to the payer, covers all selected clients.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "At least one client must be picked in the dialog. Users with the limited PCT role cannot create reminders.",
      "aliases": [
        "reminder by payer",
        "one reminder for all clients of a payer",
        "payer pays for several clients",
        "combined reminder for payer",
        "group reminder for the parent company",
        "remind the payer for all its clients"
      ],
      "anchor": "reminders-payer",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Sukurti vieną priminimą kelių klientų mokėtojui",
          "description": "Puslapyje \"Priminimai\" lauke \"Mokėtojas\" pasirinkite mokėtoją (laukas \"Klientas\" išvalomas) ir spauskite šalia esantį \"Create reminder\". Lange laukas \"Mokėtojas\" užfiksuotas šiam mokėtojui, o kairiajame skydelyje vietoj mokėtojų reikia pasirinkti bent vieną klientą. Spauskite \"Ieškoti\", kad gautumėte pasirinktų klientų nesumokėtas įmokas, atžymėkite nereikalingas ir spauskite \"Create reminder\": vienas mokėtojui adresuotas priminimas apima visus pasirinktus klientus.",
          "prerequisites": "Lange reikia pasirinkti bent vieną klientą. Ribotos PCT rolės naudotojai priminimų kurti negali.",
          "aliases": [
            "priminimas mokėtojui",
            "vienas priminimas visiems kliento mokėtojo klientams",
            "mokėtojas moka už kelis klientus",
            "bendras priminimas mokėtojui",
            "priminimas patronuojančiai įmonei"
          ]
        },
        "lv": {
          "job": "Izveidot vienu atgādinājumu vairāku klientu maksātājam",
          "description": "Lapā \"Reminders\" laukā \"Payer\" izvēlieties maksātāju (lauks \"Client\" tiek notīrīts) un noklikšķiniet blakus esošo \"Create reminder\". Logā lauks \"Payer\" ir piesaistīts šim maksātājam, un kreisajā panelī maksātāju vietā jāizvēlas vismaz viens klients. Noklikšķiniet \"Search\", lai saņemtu izvēlēto klientu neapmaksātās iemaksas, noņemiet atzīmi nevajadzīgajām un noklikšķiniet \"Create reminder\": viens maksātājam adresēts atgādinājums aptver visus izvēlētos klientus.",
          "prerequisites": "Logā jāizvēlas vismaz viens klients. Lietotāji ar ierobežoto PCT lomu nevar izveidot atgādinājumus.",
          "aliases": [
            "atgādinājums maksātājam",
            "viens atgādinājums visiem maksātāja klientiem",
            "maksātājs maksā par vairākiem klientiem",
            "kopīgs atgādinājums maksātājam",
            "atgādinājums mātes uzņēmumam"
          ]
        }
      }
    },
    {
      "id": "REM-013",
      "area": "reminders",
      "job": "Address a reminder to a private person by name",
      "description": "In the \"Create reminder\" dialog tick \"Enter payer name manually\" under the \"Payer\" field and type the person's name instead of picking a partner. The field is pre-filled with the policy payer name of the selected instalments when they have one without a partner. The documents are issued to a private person: the name is printed with no registration number, legal address or VAT line (the address prints as \"-\" on Lithuanian documents). The reminder is listed under the client and shows the name without a number in the \"Payer\" column; filtering by payer does not find it. \"Create reminder\" stays disabled while the name is empty.",
      "roles": [
        "user",
        "admin"
      ],
      "deeplink": "/reminders",
      "status": "published",
      "owner": "pct-team",
      "prerequisites": "A client must be selected to open the Create reminder dialog. Not available for a reminder created by payer.",
      "aliases": [
        "payer without partner",
        "private person pays",
        "type payer name",
        "manual payer",
        "payer not in GOS",
        "natural person payer",
        "reminder to a person",
        "invoice to private person"
      ],
      "anchor": "reminders-create-payer-manual",
      "anchor_surface": "reminders-create-button",
      "source_ref": "help:Reminders",
      "i18n": {
        "lt": {
          "job": "Adresuoti priminimą fiziniam asmeniui pagal vardą",
          "description": "Lange \"Create reminder\" po lauku \"Mokėtojas\" pažymėkite \"Įvesti mokėtojo vardą rankiniu būdu\" ir įrašykite asmens vardą ir pavardę vietoj partnerio pasirinkimo. Laukas užpildomas pasirinktų įmokų poliso mokėtojo vardu, jei jis nurodytas be partnerio. Dokumentai išrašomi fiziniam asmeniui: spausdinamas vardas be registracijos numerio, juridinio adreso ir PVM eilutės (adresas lietuviškuose dokumentuose spausdinamas kaip \"-\"). Priminimas rodomas prie kliento, stulpelyje \"Mokėtojas\" rodomas vardas be numerio; filtruojant pagal mokėtoją jis nerandamas. \"Create reminder\" neaktyvus, kol vardas tuščias.",
          "prerequisites": "Norint atverti langą Create reminder, reikia pasirinkti klientą. Negalima mokėtojui kuriamam priminimui.",
          "aliases": [
            "mokėtojas be partnerio",
            "moka fizinis asmuo",
            "įrašyti mokėtojo vardą",
            "mokėtojo nėra GOS",
            "priminimas asmeniui",
            "sąskaita fiziniam asmeniui"
          ]
        },
        "lv": {
          "job": "Adresēt atgādinājumu privātpersonai pēc vārda",
          "description": "Logā \"Create reminder\" zem lauka \"Payer\" atzīmējiet \"Ievadīt maksātāja vārdu manuāli\" un ierakstiet personas vārdu un uzvārdu, nevis izvēlieties partneri. Lauks tiek aizpildīts ar izvēlēto iemaksu polises maksātāja vārdu, ja tas norādīts bez partnera. Dokumenti tiek izrakstīti privātpersonai: tiek drukāts vārds bez reģistrācijas numura, juridiskās adreses un PVN rindas (adrese Lietuvas dokumentos tiek drukāta kā \"-\"). Atgādinājums ir redzams pie klienta, kolonnā \"Payer\" rāda vārdu bez numura; filtrējot pēc maksātāja to neatrod. \"Create reminder\" nav aktīva, kamēr vārds ir tukšs.",
          "prerequisites": "Lai atvērtu logu Create reminder, jāizvēlas klients. Nav pieejams maksātājam veidotam atgādinājumam.",
          "aliases": [
            "maksātājs bez partnera",
            "maksā privātpersona",
            "ierakstīt maksātāja vārdu",
            "maksātāja nav GOS",
            "atgādinājums personai",
            "rēķins privātpersonai"
          ]
        }
      }
    }
  ] as readonly CatalogEntry[];
